<template>
    <div>
        <div id="gs_top" onclick="">
            <div id="gs_md_ldg" style="display:none">Loading...</div>
            <div id="gs_md_err" style="display:none">The system can't perform the operation now. Try again later.</div>
            <div id="gs_md_s"></div>
            <el-dialog class="cite-dialog" title="引用" :visible.sync="dialogCiteVisible" v-if="false">
                <div id="gs_cit-bdy" style="min-height: 80px" class="gs_md_bdy">
                    <div id="cite_citd" aria-live="assertive">
                        <div id="cite_citt">
                            <table>
                                <tbody>
                                    <tr>
                                        <th scope="row" class="gs_cith">GB/T 7714</th>
                                        <td>
                                            <div tabindex="0" class="gs_citr">{{ currentCiteList.Chicago }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row" class="gs_cith">MLA</th>
                                        <td>
                                            <div tabindex="0" class="gs_citr">{{ currentCiteList.MLA }}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row" class="gs_cith">APA</th>
                                        <td>
                                            <div tabindex="0" class="gs_citr">{{ currentCiteList.APA }}</div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- <el-input style="padding-top: 10px;" type="textarea" :value="currentCiteContent" :autosize="{ minRows: 2, maxRows: 5 }"></el-input> -->
                <div style="padding-top:20px;">
                    <b>下载：</b>
                    <a class="cite-down-btn" :href="'data:application/octet-stream;charset=utf-8;base64,' + base64Bib" download="citation.bib">
                        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;BibTex</a>
                    <a class="cite-down-btn" :href="'data:application/octet-stream;charset=utf-8;base64,' + base64End" download="citation.enw">
                        <i class="fa fa-download" aria-hidden="true"></i>&nbsp;EndNote</a>
                </div>
            </el-dialog>

            <div @click="dialogCiteVisible = false" data-h="0" class="gs_md_wnw gs_md_wmw gs_vis" v-show="dialogCiteVisible">
                <div id="cite_cit" class="gs_md_d gs_ttzi gs_vis gs_abt" role="dialog" tabindex="-1" @click.stop aria-labelledby="gs_cit-t" data-cid="gs_citd" data-wfc="gs_cit-x"
                    style="top: 25vh;">
                    <div class="gs_md_hdr">
                        <div class="gs_md_hdr_b"></div>
                        <div id="gs_cit-t" class="gs_md_hdr_t" style="display: flex;justify-content: center;align-items: center;font-size: 18px;font-weight: 400;color: #666;">
                            <h2 style="font-size: 18px;font-weight: 400;color: #666;margin-left: 30px;">引用</h2>
                            <h6 style="color: #666;margin-left: 10px;">如有异常请关闭重新尝试</h6>
                        </div>
                        <a href="javascript:void(0)" @click="dialogCiteVisible = false" id="cite_cit-x" role="button" aria-label="取消" data-mdx="gs_cit"
                            class="gs_btnCLS gs_md_x gs_md_hdr_c gs_in_ib gs_btn_lrge">
                            <span class="gs_ico"></span>
                            <span class="gs_ia_notf"></span>
                            <span class="gs_lbl"></span>
                        </a>
                    </div>
                    <div id="cite_cit-bdy" style="min-height: 80px" class="gs_md_bdy">
                        <div id="cite_citd" aria-live="assertive">
                            <div id="cite_citt">
                                <table>
                                    <tbody>
                                        <tr>
                                            <th scope="row" class="gs_cith">GB/T 7714</th>
                                            <td>
                                                <div tabindex="0" class="gs_citr">{{ currentCiteList.Chicago }}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="gs_cith">MLA</th>
                                            <td>
                                                <div tabindex="0" class="gs_citr">{{ currentCiteList.MLA }}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="gs_cith">APA</th>
                                            <td>
                                                <div tabindex="0" class="gs_citr">{{ currentCiteList.APA }}</div>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div id="cite_citi">
                                <a target="_blank" class="gs_citi" :href="'data:application/octet-stream;charset=utf-8;base64,' + base64Bib" download="citation.bib">BibTeX</a>
                                <a target="_blank" class="gs_citi" :href="'data:application/octet-stream;charset=utf-8;base64,' + base64End" download="citation.enw">EndNote</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <el-dialog class="cite-dialog" title="摘要" :visible.sync="dialogSummaryVisible" width="70%">
                <div style="line-height: 30px;padding-top: 0;">
                    <el-row gutter="10">
                        <el-col :span="12">
                            <div ref="para-en" style="text-align: justify; padding: 0px 20px;line-height: 26px;" v-html="summaryDetail.text"></div>
                        </el-col>
                        <el-col :span="12">
                            <div ref="para-cn" style="text-align: justify; padding: 0px 20px;line-height: 28px;color: #078a97" v-html="summaryDetail.text_cn"></div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
            <div @click="isShowCite2 = false" data-h="0" class="gs_md_wnw gs_md_wmw gs_vis" v-show="isShowCite2">
                <div id="gs_cit" class="gs_md_d gs_ttzi gs_vis gs_abt" role="dialog" tabindex="-1" @click.stop aria-labelledby="gs_cit-t" data-cid="gs_citd" data-wfc="gs_cit-x"
                    style="top: 25vh;">
                    <div class="gs_md_hdr">
                        <div class="gs_md_hdr_b"></div>
                        <div id="gs_cit-t" class="gs_md_hdr_t" style="display: flex;justify-content: center;align-items: center;font-size: 18px;font-weight: 400;color: #666;">
                            <h2 style="font-size: 18px;font-weight: 400;color: #666;margin-left: 30px;">引用</h2>
                            <h6 style="color: #666;margin-left: 10px;">如有异常请关闭重新尝试</h6>
                        </div>
                        <a href="javascript:void(0)" @click="isShowCite2 = false" id="gs_cit-x" role="button" aria-label="取消" data-mdx="gs_cit"
                            class="gs_btnCLS gs_md_x gs_md_hdr_c gs_in_ib gs_btn_lrge">
                            <span class="gs_ico"></span>
                            <span class="gs_ia_notf"></span>
                            <span class="gs_lbl"></span>
                        </a>
                    </div>
                    <div id="gs_cit-bdy" v-loading="citeBody === ''" style="min-height: 80px" class="gs_md_bdy">
                        <div id="gs_citd" aria-live="assertive" v-html="citeBody">
                        </div>
                    </div>
                </div>
            </div>
            <div data-h="0" class="gs_md_wnw gs_md_ds gs_md_wmw">
                <div id="gs_asd" v-show="showAdvance" class="gs_md_d gs_md_ds gs_ttzi gs_vis" role="dialog" tabindex="-1" aria-labelledby="gs_asd-t" data-ifc="gs_asd_q"
                    data-wfc="gs_asd-x" style="top: 178.5px;">
                    <div class="gs_md_hdr">
                        <a href="javascript:void(0)" @click="showAdvance = false;" id="gs_asd-x" role="button" aria-label="取消" data-mdx="gs_asd"
                            class="gs_btnCLS gs_md_x gs_md_hdr_c gs_in_ib gs_btn_lrge">
                            <span class="gs_ico"></span>
                            <span class="gs_ia_notf"></span>
                            <span class="gs_lbl"></span>
                        </a>
                        <h2 id="gs_asd-t" class="gs_md_hdr_t">高级搜索</h2>
                        <div class="gs_md_hdr_b">
                            <button type="button" id="gs_asd_psb" aria-label="搜索" @click="submitAdvance" class="gs_btnG gs_in_ib gs_btn_act gs_btn_half gs_btn_lsb">
                                <span class="gs_wr">
                                    <span class="gs_ico"></span>
                                    <span class="gs_lbl"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div id="gs_asd-bdy" class="gs_md_bdy">
                        <form id="gs_asd_frm" class="gs_scl" action="/scholar">
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt" id="gs_asd_dt_t"><b>查找文章</b></div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_q">包含<b>全部</b>字词</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_q" v-model="advQuery.a" id="gs_asd_q" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_epq">包含<b>完整字句</b></label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_epq" v-model="advQuery.b" id="gs_asd_epq" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_oq">包含<b>至少一个</b>字词</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_oq" v-model="advQuery.c" id="gs_asd_oq" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_eq"><b>不包含</b>字词</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_eq" v-model="advQuery.d" id="gs_asd_eq" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_occt">出现搜索字词位置</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_asd_occtr">
                                        <span class="gs_in_ra" onclick="void(0)">
                                            <input type="radio" name="as_occt" value="any" id="gs_asd_occt_a" checked="" v-model="advQuery.pos">
                                            <label for="gs_asd_occt_a">文章中任何位置</label>
                                            <span class="gs_chk"></span>
                                            <span class="gs_cbx"></span>
                                        </span>
                                    </div>
                                    <div class="gs_asd_occtr">
                                        <span class="gs_in_ra" onclick="void(0)">
                                            <input type="radio" name="as_occt" value="title" id="gs_asd_occt_t" v-model="advQuery.pos">
                                            <label for="gs_asd_occt_t">位于文章标题</label>
                                            <span class="gs_chk"></span>
                                            <span class="gs_cbx"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_sau">显示以下<b>作者</b>所著的文章：</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_sauthors" v-model="advQuery.e" id="gs_asd_sau" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                    <div>例如：<i>丁肇中</i> 或 <i>"PJ Hayes"</i></div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_pub">显示以下<b>刊物</b>上的文章：</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_publication" v-model="advQuery.f" id="gs_asd_pub" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                    <div>例如：<i>《学术探索》</i>或<i>《Nature》</i></div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_ylo">显示在此<b>期间</b>发表的文章：</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_asd_yri">
                                        <div class="gs_in_txtw gs_in_txtm">
                                            <input type="text" class="gs_in_txt" name="as_ylo" v-model="advQuery.yl" id="gs_asd_ylo" size="4" maxlength="4" autocapitalize="off"
                                                pattern="[0-9]*">
                                            <div class="gs_in_txts"></div>
                                        </div>
                                        &nbsp;—&nbsp;
                                        <div class="gs_in_txtw gs_in_txtm"><input type="text" class="gs_in_txt" name="as_yhi" v-model="advQuery.yh" id="gs_asd_yhi" size="4"
                                                maxlength="4" autocapitalize="off" pattern="[0-9]*">
                                            <div class="gs_in_txts"></div>
                                        </div>
                                    </div>
                                    <div>例如：<i>1996</i></div>
                                </div>
                            </div>
                            <input type="hidden" name="hl" value="zh-CN"><input type="hidden" name="as_sdt" value="0,5">
                        </form>
                    </div>
                </div>

                <div id="gs_asd" class="gs_md_d gs_md_ds gs_ttzi" role="dialog" tabindex="-1" aria-labelledby="gs_asd-t" data-ifc="gs_asd_q" data-wfc="gs_asd-x">
                    <div class="gs_md_hdr">
                        <a href="javascript:void(0)" id="gs_asd-x" role="button" aria-label="Cancel" data-mdx="gs_asd" class="gs_btnCLS gs_md_x gs_md_hdr_c gs_in_ib gs_btn_lrge">
                            <span class="gs_ico"></span>
                            <span class="gs_ia_notf"></span>
                            <span class="gs_lbl"></span>
                        </a>
                        <h2 id="gs_asd-t" class="gs_md_hdr_t">Advanced search</h2>
                        <div class="gs_md_hdr_b">
                            <button type="button" id="gs_asd_psb" aria-label="Search" class="gs_btnG gs_in_ib gs_btn_act gs_btn_half gs_btn_lsb">
                                <span class="gs_wr">
                                    <span class="gs_ico"></span>
                                    <span class="gs_lbl"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div id="gs_asd-bdy" class="gs_md_bdy">
                        <form id="gs_asd_frm" class="gs_scl" action="/paper_search?">
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt" id="gs_asd_dt_t"><b>Find articles</b></div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_q">with <b>all</b> of the words</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb"><input type="text" class="gs_in_txt" name="as_q" value="1111" id="gs_asd_q" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_epq">with the <b>exact phrase</b></label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_epq" value="" id="gs_asd_epq" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt">
                                    <label for="gs_asd_oq">with <b>at least one</b> of the words</label>
                                </div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_oq" value="" id="gs_asd_oq" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_eq"><b>without</b> the words</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_eq" value="" id="gs_asd_eq" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_occt">where my words occur</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_asd_occtr">
                                        <span class="gs_in_ra" onclick="void(0)">
                                            <input type="radio" name="as_occt" value="any" id="gs_asd_occt_a" checked="">
                                            <label for="gs_asd_occt_a">anywhere in the article</label>
                                            <span class="gs_chk"></span>
                                            <span class="gs_cbx"></span>
                                        </span>
                                    </div>
                                    <div class="gs_asd_occtr">
                                        <span class="gs_in_ra" onclick="void(0)">
                                            <input type="radio" name="as_occt" value="title" id="gs_asd_occt_t">
                                            <label for="gs_asd_occt_t">in the title of the article</label>
                                            <span class="gs_chk"></span>
                                            <span class="gs_cbx"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_sau">Return articles <b>authored</b> by</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_sauthors" value="" id="gs_asd_sau" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                    <div>e.g., <i>"PJ Hayes"</i> or <i>McCarthy</i></div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_pub">Return articles <b>published</b> in</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_in_txtw gs_in_txtm gs_in_txtb">
                                        <input type="text" class="gs_in_txt" name="as_publication" value="" id="gs_asd_pub" autocapitalize="off">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                    <div>e.g., <i>J Biol Chem</i> or <i>Nature</i></div>
                                </div>
                            </div>
                            <div class="gs_asd_tr">
                                <div class="gs_asd_dt"><label for="gs_asd_ylo">Return articles <b>dated</b> between</label></div>
                                <div class="gs_asd_dd">
                                    <div class="gs_asd_yri">
                                        <div class="gs_in_txtw gs_in_txtm">
                                            <input type="text" class="gs_in_txt" name="as_ylo" value="" id="gs_asd_ylo" size="4" maxlength="4" autocapitalize="off"
                                                pattern="[0-9]*">
                                            <div class="gs_in_txts"></div>
                                        </div>
                                        &nbsp;—&nbsp;
                                        <div class="gs_in_txtw gs_in_txtm"><input type="text" class="gs_in_txt" name="as_yhi" value="" id="gs_asd_yhi" size="4" maxlength="4"
                                                autocapitalize="off" pattern="[0-9]*">
                                            <div class="gs_in_txts"></div>
                                        </div>
                                    </div>
                                    <div>e.g., <i>1996</i></div>
                                </div>
                            </div>
                            <input type="hidden" name="hl" value="en"><input type="hidden" name="as_sdt" value="0,33">
                        </form>
                    </div>
                </div>
            </div>
            <div data-h="367" class="gs_md_wnw gs_md_ds gs_md_wmw">
                <div id="gs_md_albl-d" class="gs_md_d gs_md_ds gs_ttzi" role="dialog" tabindex="-1" aria-labelledby="gs_md_albl-d-t" data-wfc="gs_md_albl-d-x">
                    <div class="gs_md_hdr">
                        <a href="javascript:void(0)" id="gs_md_albl-d-x" role="button" aria-label="Cancel" data-mdx="gs_md_albl-d"
                            class="gs_btnCLS gs_md_x gs_md_hdr_c gs_in_ib gs_btn_lrge">
                            <span class="gs_ico"></span>
                            <span class="gs_ia_notf"></span>
                            <span class="gs_lbl"></span>
                        </a>
                        <h2 id="gs_md_albl-d-t" class="gs_md_hdr_t">Saved to My library</h2>
                        <div class="gs_md_hdr_b"></div>
                    </div>
                    <div id="gs_md_albl-d-bdy" class="gs_md_bdy"></div>
                    <div class="gs_md_ftr">
                        <div class="gs_lbl_btns">
                            <button type="button" id="gs_lbd_apl" class=" gs_btn_act gs_btn_lrge">
                                <span class="gs_wr">
                                    <span class="gs_lbl">Done</span>
                                </span>
                                <span class="gs_bs"></span>
                            </button>
                            <button type="button" id="gs_lbd_trash" class=" gs_btn_olact gs_btn_lrge">
                                <span class="gs_wr">
                                    <span class="gs_lbl">Remove article</span>
                                </span>
                                <span class="gs_bs"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- [if lte IE 9]>
            <div class="gs_alrt" style="padding:16px">
                <div>Sorry, some features may not work in this version of Internet Explorer.</div>
                <div>Please use
                    <a href="https://www.google.cn/chrome/">Google Chrome</a>
                     or
                    <a href="//www.mozilla.com/firefox/">Mozilla Firefox</a>
                     for the best experience.
                </div>
            </div><![endif] -->
            <el-drawer :visible.sync="drawer" :with-header="false" :direction="'ltr'">
                <div id="gs_hdr_drw" class="gs_md_ulr gs_md_ds gs_vis" role="dialog" tabindex="-1" data-shd="gs_hdr_drs" data-wfc="gs_hdr_drw_mnu" data-cfc="gs_hdr_mnu">
                    <div id="gs_hdr_drw_in">
                        <div id="gs_hdr_drw_top">
                            <a href="javascript:void(0)" id="gs_hdr_drw_mnu" role="button" aria-controls="gs_hdr_drw" aria-label="选项" class="gs_btnMNT gs_in_ib gs_btn_lrge">
                                <span class="gs_ico"></span>
                                <span class="gs_ia_notf"></span>
                                <span class="gs_lbl"></span>
                            </a>
                            <a id="gs_hdr_drw_lgo" aria-label="首页">
                                <img data-v-5d848f11="" src="/static/img/cyto_scholar.544b73a.png" style="padding-top: 11px; width: 126px;">
                            </a>
                        </div>
                        <div>
                            <div class="gs_hdr_drw_sec">
                                <a href="javascript:;" role="menuitem" class=" gs_in_ib gs_md_li gs_md_lix gs_in_gray gs_sel">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">文章</span>
                                </a>
                                <a role="menuitem" class=" gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">个人学术档案</span>
                                </a>
                            </div>
                            <div class="gs_hdr_drw_sec">
                                <a role="menuitem" class="gs_btnPRO gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">我的个人学术档案</span>
                                </a>
                                <a role="menuitem" class="gs_btnL gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">我的图书馆</span>
                                </a>
                                <a role="menuitem" class="gs_btnM gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">快讯</span>
                                </a>
                                <a role="menuitem" class="gs_btnJ gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">统计指标</span>
                                </a>
                            </div>
                            <div class="gs_hdr_drw_sec">
                                <a href="javascript:void(0)" @click="showAdvance = true; drawer = false;" id="gs_res_drw_adv" role="menuitem"
                                    class="gs_btnADV gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">高级搜索</span>
                                </a>
                            </div>
                            <div class="gs_hdr_drw_sec">
                                <a role="menuitem" class="gs_btnP gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">设置</span>
                                </a>
                            </div>
                        </div>
                        <div id="gs_hdr_drw_bot" class="gs_hdr_drw_sec">
                            <a class=" gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                <span class="gs_ico"></span>
                                <span class="gs_ia_notf"></span>
                                <span class="gs_lbl"></span>
                            </a>
                            <img class="gs_hdr_pp" width="24" height="24">
                        </div>
                    </div>
                </div>
            </el-drawer>


            <div id="gs_hdr" role="banner">
                <a href="javascript:void(0)" id="gs_hdr_mnu" @click="drawer = type === 1 ? !drawer : false" role="button" aria-controls="gs_hdr_drw"
                    class="gs_btnMNT gs_in_ib gs_btn_lrge">
                    <span class="gs_ico"></span>
                    <span class="gs_ia_notf"></span>
                    <span class="gs_lbl"></span>
                </a>
                <router-link :to="type > 0 ? 'scholar' : 'wescholar'" id="gs_hdr_lgo" class="gs_hdr_dso" aria-label="Homepage">
                    <img src="../assets/cyto_scholar.png" v-if="type === 1" style="padding-top: 11px; width: 126px;" />
                    <img src="../assets/wescholar_logo.png" v-if="type === 0" style="padding-top: 22px; width: 157px;" />
                </router-link>
                <div id="gs_hdr_md">
                    <div id="gs_hdr_srch">
                        <form id="gs_hdr_frm" @submit.prevent="enterToQuery" method="get" class="gs_hdr_tsc"><input type="hidden" name="hl" value="en">
                            <input type="hidden" name="as_sdt" value="0,33">
                            <div class="gs_in_txtw gs_in_txtb gs_in_acw">
                                <el-input type="text" class="gs_in_txt gs_in_ac" name="q" value="1111" id="gs_hdr_tsi" size="50" maxlength="2048" :clearable="true"
                                    autocapitalize="off" autocomplete="off" aria-label="Search" data-iq="1111" data-is=".gs_qsuggest_regular li>a" dir="ltr" v-model="query">
                                </el-input>
                                <div class="gs_md_ac" id="gs_hdr_frm_ac" aria-hidden="true" ontouchstart="gs_evt_dsp(event)" onmouseover="gs_evt_dsp(event)"
                                    onmouseout="gs_evt_dsp(event)" dir="ltr">
                                    <div>
                                        <div class="gs_md_acs"></div>
                                        <ul></ul>
                                    </div>
                                </div>
                                <div class="gs_in_txts"></div>
                            </div>
                            <span id="gs_hdr_tsc">
                                <span class="gs_ico gs_ico_X"></span>
                            </span>
                            <button type="button" :disabled="gsHdrTsbDisabled" id="gs_hdr_tsb" name="btnG" aria-label="Search"
                                class="gs_btnG gs_in_ib gs_btn_act gs_btn_half gs_btn_lsb" @click="enterToQuery">
                                <span class="gs_wr">
                                    <span class="gs_ico"></span>
                                    <span class="gs_lbl"></span>
                                </span>
                            </button>
                        </form>
                    </div>
                    <div class="tool_ul_panel">
                        <ul class="tool_ul">
                            <li><a href="http://www.cytotry.com" target="_blank"><img src="../assets/site_icons/bkbc.png"><span>百科博创</span></a></li>
                            <li><router-link to="/paper/polish"><img src="../assets/site_icons/语言润色.png"><span>翻译润色</span></router-link></li>
                            <li><router-link to="/paper/check"><img src="../assets/site_icons/论文查重.png"><span>论文查重</span></router-link></li>
                            <li><router-link to="/paper/dropWeight"><img src="../assets/site_icons/论文降重.png"><span>论文降重</span></router-link></li>
                        </ul>
                        <ul class="tool_ul">
                            <li><router-link to="/gpt-tools"><img src="../assets/site_icons/openai.png"><span>AI润色</span></router-link></li>
                            <li><router-link to="/analysis/list/0"><img src="../assets/site_icons/tongji.png"><span>统计分析</span></router-link></li>
                            <li><router-link to="/journal-guide"><img src="../assets/site_icons/图片查重.png"><span>选刊助手</span></router-link></li>
                            <li><router-link to="/exchange/list/0/0"><img src="../assets/site_icons/科研置换.png"><span>科研置换</span></router-link></li>
                        </ul>
                    </div>
                    <!-- <div style="position:fixed;width: 150px; height: 152px; bottom: 100px; right: 100px; z-index: 1;">
                        <a style="position:unset;height: 100%;" href="https://www.cytotry.com/" target="_blank">
                            <img width="209" height="169" src="/static/images/adver/bkbc.png">
                        </a>
                    </div> -->

                    <div v-if="this.global.account != null" style="position:fixed;width: 64px; height: 64px; top: 300px; right: 80px; z-index: 1;">
                        <div style="position:unset;height: 100%;" @click="showAiPanel(true)">
                            <img width="64" height="64" src="/static/images/adver/aibtn.png" style="filter: drop-shadow(1px 1px 2px #999);">
                        </div>
                    </div>

                    <div v-if="aipanelShow"
                        style="background-color:#fff;position:fixed;width: 600px; height: 800px; top: 40px; right: 80px; z-index: 1001;filter: drop-shadow(20px 20px 40px #999);">
                        <div style="position:absolute;width: 40px; height: 40px;top:-20px;right:-20px" @click="showAiPanel(false)">
                            <img width="40" height="40" src="/static/images/adver/error.png">
                        </div>
                        <iframe src="https://chat.cytoagi.com/?ssotype=dotasso" width="600px" height="800px"></iframe>
                    </div>

                    <!-- <router-link to="/paper/polish"> -->
                    <!-- <img src="../assets/润色-百.png" style="width: 200px;"> -->
                    <!-- </router-link> -->
                </div>
                <!-- <div id="gs_hdr_act">
                    <a id="gs_hdr_act_s" href="https://accounts.google.com/Login?hl=en&amp;continue=https://xs2.studiodahu.com/scholar%3Fq%3D1111">登录</a>
                </div> -->
                <div id="gs_hdr_act" style="padding:10px;">
                    <AccountWiget></AccountWiget>
                </div>
            </div>
            <form action="" method="post" id="gs_alrt">
                <span id="gs_alrt_m"></span>
                <span id="gs_alrt_h"></span>
                <a id="gs_alrt_l" href="javascript:void(0)" class="gs_fm_s" data-fm="gs_alrt"></a>
            </form>
            <div id="gs_ab" class=" gs_ab_st">
                <div id="gs_ab_ico" class="gs_btnGSL"><span class="gs_ico"></span></div>
                <div id="gs_ab_ttl">
                    <div class="gs_ab_mdw">
                        <span class="gs_nph gs_nta">文章</span>
                        <div class="gs_oph gs_ota">Scholar</div>
                    </div>
                </div>
                <div id="gs_ab_md">
                    <div class="gs_ab_mdw">找到约 {{ total }} 条结果 (用时<b>0.03</b>秒)</div>
                    <!--                    <div style="display: inline-block;padding-left: 200px;color: red;"><a style="cursor: pointer;">一键翻译</a></div>
                    <div style="display: inline-block;padding-left: 50px;color: red;"><a style="cursor: pointer;">一键总结</a></div>-->
                </div>
                <div id="gs_ab_btns">
                    <a class="gs_btnPRO gs_in_ib gs_in_gray gs_nph gs_nta">
                        <span class="gs_ico"></span>
                        <span class="gs_ia_notf"></span>
                        <span class="gs_lbl">我的个人学术档案</span>
                    </a>
                    <a class="gs_btnL gs_in_ib gs_in_gray gs_nph gs_nta gs_mylib">
                        <span class="gs_ico"></span>
                        <span class="gs_ia_notf"></span>
                        <span class="gs_lbl">我的图书馆</span>
                    </a>
                    <div id="gs_res_ab_yy-r" class="gs_md_r gs_md_rmb gs_md_rmbl">
                        <button type="button" id="gs_res_ab_yy-b" aria-controls="gs_res_ab_yy-d" aria-haspopup="true" ontouchstart="gs_evt_dsp(event)"
                            class=" gs_in_se gs_btn_mnu gs_btn_flat gs_btn_lrge gs_btn_half gs_btn_lsu gs_press gs_md_tb">
                            <span class="gs_wr">
                                <span class="gs_lbl">Year</span>
                                <span class="gs_icm"></span>
                            </span>
                        </button>
                        <div id="gs_res_ab_yy-d" class="gs_md_d gs_md_ds gs_md_ulr" role="menu" tabindex="-1">
                            <div class="gs_res_ab_dd_bdy">
                                <div class="gs_res_ab_dd_sec">
                                    <a href="/scholar?q=1111&amp;hl=en&amp;as_sdt=0,33" class="gs_md_li gs_res_ab_sel" aria-checked="true" role="menuitemradio" tabindex="-1">Any
                                        time</a>
                                    <a href="/scholar?as_ylo=2023&amp;q=1111&amp;hl=en&amp;as_sdt=0,33" class="gs_md_li" role="menuitemradio" tabindex="-1">Since 2023</a>
                                    <a href="/scholar?as_ylo=2022&amp;q=1111&amp;hl=en&amp;as_sdt=0,33" class="gs_md_li" role="menuitemradio" tabindex="-1">Since 2022</a>
                                    <a href="/scholar?as_ylo=2019&amp;q=1111&amp;hl=en&amp;as_sdt=0,33" class="gs_md_li" role="menuitemradio" tabindex="-1">Since 2019</a>
                                </div>
                                <div class="gs_res_ab_dd_sec">
                                    <a href="/scholar?hl=en&amp;as_sdt=0,33&amp;q=1111" class="gs_md_li gs_res_ab_sel" aria-checked="true" role="menuitemradio" tabindex="-1">Sort
                                        by
                                        relevance</a>
                                    <a href="/scholar?hl=en&amp;as_sdt=0,33&amp;q=1111&amp;scisbd=1" class="gs_md_li" role="menuitemradio" tabindex="-1">Sort by date</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="gs_res_ab_ad-r" class="gs_md_r gs_md_rmb gs_md_rmbl">
                        <button type="button" id="gs_res_ab_ad-b" aria-label="More" aria-controls="gs_res_ab_ad-d" aria-haspopup="true" ontouchstart="gs_evt_dsp(event)"
                            class="gs_btnFLT gs_in_ib gs_btn_flat gs_btn_lrge gs_btn_half gs_btn_lsu gs_press gs_md_tb">
                            <span class="gs_wr">
                                <span class="gs_ico"></span>
                                <span class="gs_lbl"></span>
                            </span>
                        </button>
                        <div id="gs_res_ab_ad-d" class="gs_md_d gs_md_ds gs_md_ulr" role="menu" tabindex="-1">
                            <div class="gs_res_ab_dd_bdy">
                                <div class="gs_res_ab_dd_sec">
                                    <a href="/scholar?q=1111&amp;hl=en&amp;as_sdt=0,33" class="gs_md_li gs_res_ab_sel" aria-checked="true" role="menuitemradio" tabindex="-1">Any
                                        type</a>
                                    <a href="/scholar?q=1111&amp;hl=en&amp;as_sdt=0,33&amp;as_rr=1" class="gs_md_li" role="menuitemradio" tabindex="-1">Review articles</a>
                                </div>
                                <div class="gs_res_ab_dd_sec">
                                    <a href="/scholar?as_sdt=7,33&amp;q=1111&amp;hl=en" tabindex="-1" role="menuitemcheckbox" aria-checked="false" data-s="0"
                                        class="gs_cb_gen gs_in_cb gs_md_li">
                                        <span class="gs_lbl">include patents</span>
                                        <span class="gs_chk"></span>
                                        <span class="gs_cbx"></span>
                                    </a>
                                    <a href="/scholar?as_vis=1&amp;q=1111&amp;hl=en&amp;as_sdt=0,33" tabindex="-1" role="menuitemcheckbox" aria-checked="true" data-s="1"
                                        class="gs_cb_gen gs_in_cb gs_md_li gs_sel">
                                        <span class="gs_lbl">include citations</span>
                                        <span class="gs_chk"></span>
                                        <span class="gs_cbx"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="gs_bdy" v-loading="((data === null && data1 === null) || data_loading === true)">
                <div id="gs_bdy_sb" role="navigation" v-if="type === 0">
                    <div id="gs_bdy_sb_in">
                        <div class="gs_bdy_sb_sec">
                            <ul id="gs_res_sb_yyl">
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 0 && endTime == 0 }"><a href="javascript:;" @click="filterTime(0, 0)">时间不限</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2024 && endTime == 0 }"><a href="javascript:;" @click="filterTime(2024, 0)">2024以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2023 && endTime == 0 }"><a href="javascript:;" @click="filterTime(2023, 0)">2023以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2022 && endTime == 0 }"><a href="javascript:;" @click="filterTime(2022, 0)">2022以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2019 && endTime == 0 }"><a href="javascript:;" @click="filterTime(2019, 0)">2019以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime > 0 && startTime < 2019 || endTime != 0 }">
                                    <el-popover placement="bottom" width="160" v-model="customTimeVisible">
                                        <el-form ref="form" :model="customTimeForm" label-width="70px">
                                            <el-form-item label="开始年份">
                                                <el-input v-model="customTimeForm.start"></el-input>
                                            </el-form-item>
                                            <el-form-item label="结束年份" style="padding-top: 10px">
                                                <el-input v-model="customTimeForm.end"></el-input>
                                            </el-form-item>
                                        </el-form>
                                        <div style="text-align: right; margin: 0;padding-top: 10px;">
                                            <el-button type="primary" size="mini" @click="filterCustomTime">确定</el-button>
                                        </div>
                                        <a href="javascript:;" slot="reference">自定义范围...</a>
                                    </el-popover>
                                </li>
                            </ul>
                            <form id="gs_res_sb_yyf" class="gs_pad" action="/scholar" style="display:none">
                                <input type="hidden" name="q" value="1111">
                                <input type="hidden" name="hl" value="en">
                                <input type="hidden" name="as_sdt" value="0,33">
                                <div class="gs_res_sb_yyr">
                                    <div class="gs_in_txtw gs_in_txtm">
                                        <input type="text" class="gs_in_txt" name="as_ylo" value="" id="gs_as_ylo" size="4" maxlength="4" autocapitalize="off" pattern="[0-9]*">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                    —
                                    <div class="gs_in_txtw gs_in_txtm">
                                        <input type="text" class="gs_in_txt" name="as_yhi" value="" size="4" maxlength="4" autocapitalize="off" pattern="[0-9]*">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                                <div class="gs_res_sb_yyr">
                                    <button type="submit" class=" gs_btn_lsb">
                                        <span class="gs_wr">
                                            <span class="gs_lbl">Search</span>
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <!--                        <ul class="gs_bdy_sb_sec">
                            <li class="gs_ind gs_bdy_sb_sel"><a
                                href="/scholar?hl=en&amp;as_sdt=0,33&amp;q=1111">相关性排序</a></li>
                            <li class="gs_ind"><a
                                href="/scholar?hl=en&amp;as_sdt=0,33&amp;q=1111&amp;scisbd=1">按日期排序</a></li>
                        </ul>-->

                        <ul class="gs_bdy_sb_sec">
                            <li><a href="javascript:;">按相关性排序</a></li>
                            <li><a href="javascript:;">按日期排序</a></li>
                        </ul>
                        <ul class="gs_bdy_sb_sec">
                            <li><a href="javascript:;">不限语言</a></li>
                            <li><a href="javascript:;">中文网页</a></li>
                            <li><a href="javascript:;">简体中文网页</a></li>
                        </ul>
                        <ul class="gs_bdy_sb_sec">
                            <li><a href="javascript:;">类型不限</a></li>
                            <li><a href="javascript:;">评论性文章</a></li>
                        </ul>
                        <ul class="gs_bdy_sb_sec">
                            <li class="gs_inw">
                                <a href="javascript:;" role="checkbox" aria-checked="false" data-s="0" class="gs_cb_gen gs_in_cb">
                                    <span class="gs_lbl">包括专利</span>
                                    <span class="gs_chk"></span>
                                    <span class="gs_cbx"></span>
                                </a>
                            </li>
                            <li class="gs_inw">
                                <a href="javascript:;" role="checkbox" aria-checked="true" data-s="1" class="gs_cb_gen gs_in_cb gs_sel">
                                    <span class="gs_lbl">包含引用</span>
                                    <span class="gs_chk"></span>
                                    <span class="gs_cbx"></span>
                                </a>
                            </li>
                        </ul>
                        <div class="gs_bdy_sb_sec">
                            <a href="javascript:;" id="gs_bdy_sb_ca" class="gs_btnM gs_in_ib">
                                <span class="gs_ico"></span>
                                <span class="gs_ia_notf"></span>
                                <span class="gs_lbl">创建快讯</span>
                            </a>
                        </div>
                        <div id="gsAdvertisement">
                            <!--                        <img @click="Hidden()" src="../assets/code_close.png" style="width: 15px; position: absolute; right: 2px; top: 2px;">-->
                            <!-- <img src="/static/images/adver/advertisement2.png" style="width: 180px;" @click="imgClick()">
                            <a href="https://www.citexs.com/AIHelp?s=dtsy" target="_blank"><img src="/static/images/adver/scidoc.png" style="width: 180px;"></a>
                            <a href="https://ibiling.cn/paper?from=dtsypaper02" target="_blank"><img src="/static/images/adver/ibiling_banner.jpg" style="width: 180px;"></a> -->
                            <!-- <a href="https://www.aipaperpass.com?pic=R5J5" target="_blank"><img src="/static/images/adver/aipaperpass_banner.png" style="width: 180px;"></a> -->
                            <a href="/static/images/adver/organoid_banner.png" target="_blank"><img src="/static/images/adver/organoid_banner.png" style="width: 180px;"></a>
                            <a href="/static/images/adver/cell_advertising.png" target="_blank"><img src="/static/images/adver/cell_advertising.png" style="width: 180px;"></a>
                            <!-- <img src="/static/images/adver/jiujiu.jpg" style="width: 180px;"> -->
                            <!-- <div style="width: 180px;text-align: center;margin-top: 10px;">
                                <p style="width:100%;font-size: large;">扫码入群</p>
                                <img src="/static/images/adver/wechat_group.jpg" style="width:80%">
                            </div>
                            <div class="adv-image-panle" style="width: 180px;text-align: center;margin-top: 20px;">
                                <p style="width:100%;font-size: large;">扫码添加公众号</p>
                                <img src="/static/images/adver/wechat_mp.jpg" style="width:85%">
                            </div> -->
                        </div>
                    </div>
                </div>
                <div id="gs_bdy_sb" role="navigation" v-if="type === 1">
                    <div id="gs_bdy_sb_in" v-show="!$route.query.ex">
                        <div class="gs_bdy_sb_sec">
                            <ul id="gs_res_sb_yyl">
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 0 && endTime == 0 }">
                                    <a href="javascript:;" @click="filterTime(0, 0)">时间不限</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2024 && endTime == 0 }">
                                    <a href="javascript:;" @click="filterTime(2024, 0)">2024以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2023 && endTime == 0 }">
                                    <a href="javascript:;" @click="filterTime(2023, 0)">2023以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2022 && endTime == 0 }">
                                    <a href="javascript:;" @click="filterTime(2022, 0)">2022以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': startTime == 2019 && endTime == 0 }">
                                    <a href="javascript:;" @click="filterTime(2019, 0)">2019以来</a>
                                </li>
                                <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': !([0, '0', '2019', '2022', '2023'].includes(this.startTime)) || this.endTime != 0 }">
                                    <a href="javascript:;" @click="showCustomTime = !showCustomTime">自定义范围...</a>
                                </li>
                            </ul>
                            <div id="gs_res_sb_yyf" class="gs_pad" v-show="showCustomTime">
                                <div class="gs_res_sb_yyr">
                                    <div class="gs_in_txtw gs_in_txtm">
                                        <input type="text" class="gs_in_txt" name="as_ylo" value="" id="gs_as_ylo" size="4" maxlength="4" autocapitalize="off" pattern="[0-9]*"
                                            v-model="customTimeForm.start">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                    —
                                    <div class="gs_in_txtw gs_in_txtm">
                                        <input type="text" class="gs_in_txt" name="as_yhi" value="" size="4" maxlength="4" autocapitalize="off" pattern="[0-9]*"
                                            v-model="customTimeForm.end">
                                        <div class="gs_in_txts"></div>
                                    </div>
                                </div>
                                <div class="gs_res_sb_yyr">
                                    <button @click="filterCustomTime" class=" gs_btn_lsb">
                                        <span class="gs_wr">
                                            <span class="gs_lbl">搜索</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ul class="gs_bdy_sb_sec">
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': sortType == 0 }">
                                <a href="javascript:;" @click="scisbd = ''; sortType = 0; jumpTo()">按相关性排序</a>
                            </li>
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': sortType == 1 }">
                                <a href="javascript:;" @click="scisbd = '1'; page = 1; sortType = 1; jumpTo();">按日期排序</a>
                            </li>
                        </ul>
                        <ul class="gs_bdy_sb_sec">
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': langType == 0 }">
                                <a href="javascript:;" @click="lr = ''; page = 1; langType = 0; jumpTo();">不限语言</a>
                            </li>
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': langType == 1 }">
                                <a href="javascript:;" @click="lr = 'lang_zh-CN|lang_zh-TW'; page = 1; langType = 1; jumpTo();">中文网页</a>
                            </li>
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': langType == 2 }">
                                <a href="javascript:;" @click="lr = 'lang_zh-CN'; page = 1; langType = 2; jumpTo();">简体中文网页</a>
                            </li>
                        </ul>
                        <ul class="gs_bdy_sb_sec">
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': articleType === 0 }">
                                <a href="javascript:;" @click="page = 1; articleType = 0; jumpTo();">类型不限</a>
                            </li>
                            <li :class="{ 'gs_ind': true, 'gs_bdy_sb_sel': articleType === 1 }">
                                <a href="javascript:;" @click="page = 1; articleType = 1; jumpTo();">评论性文章</a>
                            </li>
                        </ul>
                        <ul class="gs_bdy_sb_sec">
                            <li class="gs_inw">
                                <a href="javascript:;" role="checkbox" aria-checked="false" data-s="0" class="gs_cb_gen gs_in_cb">
                                    <span class="gs_lbl">包括专利</span>
                                    <span class="gs_chk"></span>
                                    <span class="gs_cbx"></span>
                                </a>
                            </li>
                            <li class="gs_inw">
                                <a href="javascript:;" role="checkbox" aria-checked="true" data-s="1" class="gs_cb_gen gs_in_cb gs_sel">
                                    <span class="gs_lbl">包含引用</span>
                                    <span class="gs_chk"></span>
                                    <span class="gs_cbx"></span>
                                </a>
                            </li>
                        </ul>
                        <div class="gs_bdy_sb_sec">
                            <a href="javascript:;" id="gs_bdy_sb_ca" class="gs_btnM gs_in_ib">
                                <span class="gs_ico"></span>
                                <span class="gs_ia_notf"></span>
                                <span class="gs_lbl">创建快讯</span>
                            </a>
                        </div>
                    </div>
                    <!--                    <div id="gsAdvertisement" v-show="Hidden1 == 'block'">-->
                    <div id="gsAdvertisement">
                        <!-- <img @click="Hidden()" src="../assets/code_close.png" style="width: 15px; position: absolute; right: 2px; top: 2px;">-->
                        <!-- <img src="/static/images/adver/advertisement2.png" style="width: 180px;" @click="imgClick()">
                        <a href="https://www.citexs.com/AIHelp?s=dtsy" target="_blank"><img src="/static/images/adver/scidoc.png" style="width: 180px;"></a>
                        <a href="https://ibiling.cn/paper?from=dtsypaper02" target="_blank"><img src="/static/images/adver/ibiling_banner.jpg" style="width: 180px;"></a> -->
                        <!-- <a href="https://www.aipaperpass.com?pic=R5J5" target="_blank"><img src="/static/images/adver/aipaperpass_banner.png" style="width: 180px;"></a> -->
                        <a href="/static/images/adver/organoid_banner.png" target="_blank"><img src="/static/images/adver/organoid_banner.png" style="width: 180px;"></a>
                        <a href="/static/images/adver/cell_advertising.png" target="_blank"><img src="/static/images/adver/cell_advertising.png" style="width: 180px;"></a>

                        <!-- <img src="/static/images/adver/jiujiu.jpg" style="width: 180px;"> -->
                        <!-- <div style="width: 180px;text-align: center;margin-top: 10px;">
                            <p style="width:100%;font-size: large;">扫码入群</p>
                            <img src="/static/images/adver/wechat_group.jpg" style="width:80%">
                        </div>
                        <div class="adv-image-panle" style="width: 180px;text-align: center;margin-top: 20px;">
                            <p style="width:100%;font-size: large;">扫码添加公众号</p>
                            <img src="/static/images/adver/wechat_mp.jpg" style="width:85%">
                        </div> -->
                        <!-- <img src="/static/images/adver/advertisement2.png" style="width: 180px;" @click="imgClick()"> -->
                    </div>
                </div>

                <div id="gs_bdy_ccl" role="main">
                    <div id="gs_res_glb" style="display:none" data-ttl="1111 - Google Scholar" data-lph=""
                        data-sva="/citations?hl=en&amp;xsrf=&amp;continue=/scholar%3Fq%3D1111%26hl%3Den%26as_sdt%3D0,33&amp;citilm=1&amp;update_op=library_add&amp;info={id}&amp;ei=ckvGY-TrENLAywSQtZC4AQ&amp;json="
                        data-sval="/citations?hl=en&amp;xsrf=&amp;continue=/scholar%3Fq%3D1111%26hl%3Den%26as_sdt%3D0,33%26scisig%3DckvGY-TrENLAywSQtZC4AQ%26dts%3D%7Bid%7D&amp;citilm=1&amp;update_op=library_add&amp;info={id}&amp;ei=AAGBfm0AAAAAY8ZNyhhyiBHNL-yRwJgZRDCZvejB2n0d&amp;view_op=list_article_labels"
                        data-tra="/citations?hl=en&amp;xsrf=&amp;continue=/scholar%3Fq%3D1111%26hl%3Den%26as_sdt%3D0,33&amp;citilm=1&amp;json=&amp;update_op=trash_citations&amp;s={id}"
                        data-via="/citations?view_op=view_citation&amp;continue=/scholar%3Fq%3D1111%26hl%3Den%26as_sdt%3D0,33&amp;citilm=1&amp;citation_for_view={id}&amp;hl=en&amp;oi=saved"
                        data-lsl="" data-lpu="" data-lsm="Saved to <a href=&quot;/scholar?scilib=1&amp;amp;scioq=1111&amp;amp;hl=en&amp;amp;as_sdt=0,33&quot;>your library</a>."
                        data-ahq="1111" data-gsb="" data-rfr="/scholar?q=related:{id}:scholar.google.com/&amp;output=rfrra&amp;scioq=1111&amp;ei=ckvGY-TrENLAywSQtZC4AQ&amp;hl=en"
                        data-usv="">
                    </div>
                    <div id="gs_res_lbtpl" style="display:none"></div>
                    <div id="gs_res_ccl">
                        <div id="gs_res_ccl_top"></div>
                        <div id="gs_res_ccl_mid">
                            <div class="gs_r gs_or gs_scl" v-for="(row, i) in (data === null ? [] : data.data)" :key="i" data-lid="" data-rp="2">
                                <div class="gs_ggs gs_fl">
                                    <div class="gs_ggsd">
                                        <div class="gs_or_ggsm" ontouchstart="gs_evt_dsp(event)" tabindex="-1" v-if="row.openAccessPdf != null">
                                            <a :href="row.openAccessPdf.url" target="_blank"><span class="gs_ctg2">[PDF]</span> {{ getShortUrl(row.openAccessPdf.url) }}</a>
                                        </div>
                                        <div class="gs_or_ggsm" ontouchstart="gs_evt_dsp(event)" tabindex="-1" v-if="row.externalIds.DOI != null">
                                            <a :href="'https://sci-hub.st/' + row.externalIds.DOI" target="_blank"><span class="gs_ctg2" style="color:red">[PDF]</span>
                                                <span class="gs_ctg2" style="color:red">一键下载</span></a>
                                        </div>
                                        <!-- <a class="fav-button" @click="addCollection(row)" style="font-weight: bold;">
                                            <i class="fa fa-star-o" aria-hidden="true" style="margin-right: 5px; color: #14aab9; "></i>收藏
                                        </a> -->

                                        <span @click="getAbstractTranslate(row)" v-if="row.abstract != null"
                                                style="    font-size: 13px;color:#0070c0; font-weight: bold;cursor: pointer;">[中英文摘要]</span>
                                    </div>
                                </div>
                                <div class="gs_ri">
                                    <h3 class="gs_rt" ontouchstart="gs_evt_dsp(event)">

                                        <a id="jXTRflCgvKoJ" :href="row.externalIds.DOI != null ? 'https://dx.doi.org/' + row.externalIds.DOI : row.url" target="_blank" lang="en"
                                            v-html="row.title"></a>
                                    </h3>
                                    <div class="gs_a">
                                        <a v-if="row.authors[0] != null" target="_blank">{{ row.authors[0].name }}</a>
                                        <span v-if="row.journal != null"> - {{ row.journal.name }}</span>
                                        - {{ row.year }} -
                                        <a v-if="row.publicationVenue != null" :href="row.publicationVenue.url" target="_blank">{{ getShortUrl(row.publicationVenue.url) }}
                                        </a>
                                        <span class="search-paper-journal-info" v-if="row.journal != null">
                                            <!--                                            <span v-if="row.publicationTypes!=null"> - {{row.publicationTypes.join(" ")}}</span>-->
                                            <br v-if="row.journal.if != null" />
                                            <el-tag v-if="row.journal.if != null" size="mini" :style="{ 'background': computeIfColor(row.journal.if) }">IF：{{ row.journal.if
                                                }}</el-tag>
                                            &nbsp;&nbsp;&nbsp;
                                            <el-tag v-if="row.journal.jcr != null" size="mini" :style="{ 'background': computePartitionColor(row.journal.jcr) }">JCR分区：{{
                                                row.journal.jcr }}</el-tag>
                                            &nbsp;&nbsp;&nbsp;
                                            <el-tag v-if="row.journal.partition != null" size="mini"
                                                :style="{ 'background': computePartitionColor(row.journal.partition) }">中科院分区：{{
                                                    row.journal.partition }}</el-tag>
                                        </span>
                                    </div>
                                    <div class="text-wrap">
                                        <input type="checkbox" class="expand-cb" :id="'expand' + i">
                                        <div class="gs_rs text-abstract" lang="en"
                                            style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">
                                            <label class="expand" :for="'expand' + i"></label>
                                            <!-- <span @click="getAbstractTranslate(row)" v-if="row.abstract != null"
                                                style="color:#0070c0; font-weight: bold;cursor: pointer;">[翻译]</span> -->
                                            <span v-if="row.abstract != null" style="color:red; font-weight: bold;">[摘要]</span>
                                            <span class="inner" v-html="row.abstract"></span>

                                            <!-- <template v-if="row.abstract_cn != null">
                                                <br>
                                                <span style="color:red; font-weight: bold;">[摘要]</span>
                                                <span class="inner" v-html="row.abstract_cn"></span>
                                            </template> -->
                                        </div>
                                    </div>

                                    <div class="gs_fl">
                                        <a href="javascript:void(0)" class="gs_or_sav gs_or_btn" role="button">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M7.5 11.57l3.824 2.308-1.015-4.35 3.379-2.926-4.45-.378L7.5 2.122 5.761 6.224l-4.449.378 3.379 2.926-1.015 4.35z"></path>
                                            </svg>
                                            <span class="gs_or_btn_lbl">保存</span></a>

                                        <!-- <a href="javascript:void(0)">相关文章</a>-->
                                        <a href="javascript:void(0)" @click="showCite(row)" class="gs_or_cit gs_or_btn gs_nph" role="button" aria-controls="gs_cit"
                                            aria-haspopup="true">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M6.5 3.5H1.5V8.5H3.75L1.75 12.5H4.75L6.5 9V3.5zM13.5 3.5H8.5V8.5H10.75L8.75 12.5H11.75L13.5 9V3.5z"></path>
                                            </svg>
                                            <span>引用</span>
                                        </a>
                                        <router-link :to="'/paper_search?type=0&ex=1&cites=' + row.paperId" target="_blank">被引用次数: {{ row.citationCount }}</router-link>
                                        <a href="javascript:void(0)">相关文章</a>
                                        <a href="javascript:void(0)" class="gs_nph">所有版本</a>
                                        <a href="javascript:void(0)" title="More" class="gs_or_mor" role="button">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M0.75 5.5l2-2L7.25 8l-4.5 4.5-2-2L3.25 8zM7.75 5.5l2-2L14.25 8l-4.5 4.5-2-2L10.25 8z"></path>
                                            </svg>
                                        </a>
                                        <a href="/scholar?output=instlink&amp;q=info:jXTRflCgvKoJ:scholar.google.com/&amp;hl=en&amp;as_sdt=0,33&amp;scillfp=13824586945085388994&amp;oi=llo"
                                            class="gs_or_nvi">Library
                                            Search</a>
                                        <a href="javascript:void(0)" title="Fewer" class="gs_or_nvi gs_or_mor" role="button">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M7.25 5.5l-2-2L0.75 8l4.5 4.5 2-2L4.75 8zM14.25 5.5l-2-2L7.75 8l4.5 4.5 2-2L11.75 8z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="gs_r gs_or gs_scl" v-for="(row, i) in (data1 === null ? [] : data1.data)" :key="i" data-lid="" data-rp="2">
                                <div class="gs_ggs gs_fl">
                                    <div class="gs_ggsd">
                                        <div class="gs_or_ggsm" ontouchstart="gs_evt_dsp(event)" tabindex="-1" v-if="row.openAccessUrl != null">
                                            <a :href="row.openAccessUrl" target="_blank" v-html="row.openAccessHtml"></a>
                                        </div>
                                        <div class="gs_or_ggsm" ontouchstart="gs_evt_dsp(event)" tabindex="-1" v-if="row.doi != null">
                                            <a :href="'https://www.sci-hub.' + (scihubMirror === 0 ? 'st/' : scihubMirror === 1 ? 'se/' : 'ru/') + row.doi"
                                                @click="scihubMirror = (scihubMirror + 1) % 3" target="_blank">
                                                <span class="gs_ctg2" style="color:red">[PDF]</span>
                                                <span class="gs_ctg2" style="color:red">一键下载</span>
                                            </a>
                                        </div>
                                        <div class="gs_or_ggsm" ontouchstart="gs_evt_dsp(event)" tabindex="-1" v-if="row.doi == null">
                                            <a :href="'https://www.sci-hub.' + (scihubMirror === 0 ? 'st/' : scihubMirror === 1 ? 'se/' : 'ru/') + row.url"
                                                @click="scihubMirror = (scihubMirror + 1) % 3" target="_blank">
                                                <span class="gs_ctg2" style="color:red">[PDF]</span>
                                                <span class="gs_ctg2" style="color:red">一键下载</span>
                                            </a>
                                        </div>
                                        <!--<div>
                                            <div v-for="(item,index) in tree" :key="index">
                                                <div class="box" :class="check==item.label?'activate':''" @click="articleToggle(item)">
                                                    <i style="margin: 0px 5px;" :class="['fa', 'fa-th']"></i>
                                                    <div> {{item.label }}</div>
                                                </div>
                                                <div class="subbox" :class="check==a.id?'activate':''" @click="handleNodeClick(a)"  v-for="(a,i) in item.children" :key="i">
                                                    {{ a.label }}
                                                </div>
                                            </div>
                                        </div>-->
                                    </div>
                                </div>
                                <div class="gs_ri">
                                    <h3 class="gs_rt" ontouchstart="gs_evt_dsp(event)" v-html="row.title"></h3>
                                    <div class="gs_a">
                                        <!-- <a v-if="row.authors[0]!=null">{{row.authors[0].name}}</a>
                                        <span v-if="row.journal!=null"> - {{ row.journal.name }}</span>
                                         - {{row.year}} -
                                        <a v-if="row.publicationVenue!=null" :href="row.publicationVenue.url" target="_blank">{{getShortUrl(row.publicationVenue.url)}}
                                        </a> -->
                                        <router-link :to="row.authorLink" v-if="row.authorLink" style="text-decoration: underline;">{{ row.author }}</router-link>
                                        <a href="javascript:" v-else>{{ row.author }}</a>
                                        <span> - {{ row.journal }}</span>
                                        - {{ row.year }} -
                                        <a>{{ row.publisher }}</a>
                                        <span class="search-paper-journal-info">
                                            <!-- <span v-if="row.publicationTypes!=null"> - {{row.publicationTypes.join(" ")}}</span> -->
                                            <br v-if="row.if != null" />
                                            <el-tag v-if="row.if != null" size="mini" :style="{ 'background': computeIfColor(row.if) }">IF：{{ row.if }}</el-tag>
                                            &nbsp;&nbsp;&nbsp;
                                            <el-tag v-if="row.jcr != null" size="mini" :style="{ 'background': computePartitionColor(row.jcr) }">JCR分区：{{ row.jcr }}</el-tag>
                                            &nbsp;&nbsp;&nbsp;
                                            <el-tag v-if="row.partition != null" size="mini" :style="{ 'background': computePartitionColor(row.partition) }">中科院分区：{{ row.partition
                                                }}</el-tag>
                                        </span>
                                    </div>
                                    <div class="text-wrap">
                                        <div class="gs_rs text-abstract" lang="en"
                                            style="overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;">
                                            <span class="inner" v-html="row.abstract"></span>
                                        </div>
                                    </div>

                                    <div class="gs_fl">
                                        <a href="javascript:void(0)" class="gs_or_sav gs_or_btn" role="button">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M7.5 11.57l3.824 2.308-1.015-4.35 3.379-2.926-4.45-.378L7.5 2.122 5.761 6.224l-4.449.378 3.379 2.926-1.015 4.35z"></path>
                                            </svg>
                                            <span class="gs_or_btn_lbl">保存</span>
                                        </a>
                                        <a href="javascript:void(0)" @click="showCite2(row.cid)" class="gs_or_cit gs_or_btn gs_nph" role="button" aria-controls="gs_cit"
                                            aria-haspopup="true">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M6.5 3.5H1.5V8.5H3.75L1.75 12.5H4.75L6.5 9V3.5zM13.5 3.5H8.5V8.5H10.75L8.75 12.5H11.75L13.5 9V3.5z"></path>
                                            </svg>
                                            <span>引用</span>
                                        </a>
                                        <router-link :to="'/paper_search?type=1&ex=1&cites=' + row.did" target="_blank">被引用次数: {{ row.citationCount }}</router-link>
                                        <router-link :to="'/paper_search?type=1&ex=2&related=' + row.cid" target="_blank">相关文章</router-link>
                                        <router-link :to="'/paper_search?type=1&ex=3&cluster=' + row.did" target="_blank">所有版本</router-link>
                                        <a href="javascript:void(0)" title="More" class="gs_or_mor" role="button">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M0.75 5.5l2-2L7.25 8l-4.5 4.5-2-2L3.25 8zM7.75 5.5l2-2L14.25 8l-4.5 4.5-2-2L10.25 8z"></path>
                                            </svg>
                                        </a>
                                        <a href="javascript:" class="gs_or_nvi">Library Search</a>
                                        <a href="javascript:void(0)" title="Fewer" class="gs_or_nvi gs_or_mor" role="button">
                                            <svg viewBox="0 0 15 16" class="gs_or_svg">
                                                <path d="M7.25 5.5l-2-2L0.75 8l4.5 4.5 2-2L4.75 8zM14.25 5.5l-2-2L7.75 8l4.5 4.5 2-2L11.75 8z"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="gs_res_ccl_bot">
                            <div class="gs_r gs_alrt_btm gs_oph gs_ota">
                                <a href="/scholar_alerts?view_op=create_alert_options&amp;hl=en&amp;alert_query=1111&amp;alert_params=%3Fhl%3Den%26as_sdt%3D0,33"
                                    class="gs_btnM gs_in_ib">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">Create alert</span>
                                </a>
                            </div>
                            <div id="gs_n" role="navigation">
                                <center>
                                    <div v-show="data1 != null && data1.data === undefined">
                                        请确认你是真人而非机器
                                        <el-button type="text" @click="updateQuery">确认</el-button>
                                    </div>
                                    <img src="../assets/cytoscholar_page.png" style="width: 274px;" />
                                    <el-pagination @current-change="turnPage" layout="prev, pager, next" :total="total" :current-page.sync="page" prev-text="上一页" next-text="下一页">
                                    </el-pagination>
                                </center>
                            </div>
                        </div>
                        <!-- 728X90 -->
                    </div>
                </div>
            </div>
            <div id="rightBottomAd" style="position: fixed; bottom: 20px; right: 0px;  top: 660px;">
                <a href="/static/images/adver/advertising.png" target="_blank">
                    <img src="/static/images/adver/advertising.png" style="width: 250px; height: auto;">
                </a>
            </div>
            <div id="gs_ftr_sp" role="presentation"></div>
            <div id="gs_ftr" role="contentinfo">
                <div id="gs_ftr_rt"><a>帮助</a><a>隐私</a><a>条款</a></div>
            </div>
        </div>
        <!-- <remote-js src="https://cdn.jsdelivr.net/gh/pcooksey/bibtex-js@1.0.0/src/bibtex_js.min.js"></remote-js> -->

    </div>
</template>

<script>
import request, { BaseUrl } from "../utils/request";
import bibtexParse from '@orcid/bibtex-parse-js';
import { Base64 } from 'js-base64';
import AccountWiget from "./AccountWiget";
import axios from "axios";

export default {
    name: "PaperSearchResult",
    components: {
        AccountWiget,
        'remote-js': {
            render(createElement) {
                return createElement('script', { attrs: { type: 'text/javascript', src: this.src } });
            },
            props: {
                src: { type: String, required: true },
            },
        },
    },
    data() {
        return {
            gsHdrTsbDisabled: false,
            type: 0,
            query: '',
            advQuery: {
                pos: 'any'
            },
            /*tree: [{"id":"1","label":"总结本篇","children":[{"id":"2","label":"总结标题"},{"id":"3","label":"总结内容"}]}],*/
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            page: 1,
            scisbd: '',
            sortType: 0,
            langType: 0,
            articleType: 0,
            lr: '',
            data: null,
            lastTimer: 0,
            scihubMirror: 0,
            data1: null,
            data_loading: false,
            total: 0,
            drawer: false,
            showAdvance: false,
            showCustomTime: false,
            citeBody: '',
            isShowCite2: false,
            dialogCiteVisible: false,
            dialogSummaryVisible: false,

            summaryDetail: {
                date: '',
                author: '',
                doi: '',
                source: '',
                date: '',
                text: '',
                text_cn: '',
            },
            currentCiteStyle: null,
            currentCiteContent: '',
            currentCiteList: {
                'MLA': '',
                'APA': '',
                'Chicago': '',
            },
            base64Bib: '',
            base64End: '',
            startTime: 0,
            endTime: 0,
            customTimeVisible: false,
            customTimeForm: {
                start: '',
                end: '',
            },
            Hidden1: 'block',
            aipanelShow: false
        }
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'updateQuery'
    },
    created() {
        this.updateQuery()
    },
    methods: {
        computeIfColor(vIf) {
            if (vIf > 20) return '#FF000082'
            if (vIf > 10) return '#FF66CC82'
            if (vIf > 5) return '#0099FF82'
            if (vIf > 3) return '#f3e10a82'
            if (vIf > 0) return '#33CC3382'
            return '#A6A6A682'
        },
        computePartitionColor(p) {
            p = p.replace(/\D/g, "")
            if (p == 1) return '#FF006682'
            if (p == 2) return '#0099FF82'
            if (p == 3) return '#f3e10a82'
            return '#33CC3382'
        },
        showAiPanel(status) {
            this.aipanelShow = status
        },
        switchCiteStyle(type) {
            let r = bibtexParse.toJSON(this.currentCiteStyle)[0];
            let tags = r.entryTags
            if (!tags.year) tags.year = ''
            if (!tags.booktitle) tags.booktitle = ''
            if (!tags.volume) tags.volume = ''
            if (!tags.page) tags.page = ''

            switch (type) {
                case 0:
                    this.currentCiteContent = this.currentCiteStyle
                    break;
                case 1:
                    let s = tags.author + ' ' + tags.title + ' ' + tags.booktitle + ' (' + tags.year + '):' + tags.volume + ' ' + tags.page
                    this.currentCiteContent = s
                    break;
                case 2:
                    s = tags.author + ' (' + tags.year + ')' + tags.title + ' ' + tags.booktitle + ' ' + tags.volume + ' ' + tags.page
                    this.currentCiteContent = s
                    break;
                case 3:
                    s = tags.author + ' ' + tags.title + ' ' + tags.booktitle + ' ' + tags.volume + ' (' + tags.year + '): ' + tags.page
                    this.currentCiteContent = s
                    break;
            }
        },
        getCiteValue() {

            let r = bibtexParse.toJSON(this.currentCiteStyle)[0];
            let tags = r.entryTags
            if (!tags.year) tags.year = ''
            if (!tags.booktitle) tags.booktitle = ''
            if (!tags.volume) tags.volume = ''
            if (!tags.page) tags.page = ''
            this.currentCiteList = {
                'MLA': tags.author + ' ' + tags.title + ' ' + tags.booktitle + ' (' + tags.year + '):' + tags.volume + ' ' + tags.page,
                'APA': tags.author + ' (' + tags.year + ')' + tags.title + ' ' + tags.booktitle + ' ' + tags.volume + ' ' + tags.page,
                'Chicago': tags.author + ' ' + tags.title + ' ' + tags.booktitle + ' ' + tags.volume + ' (' + tags.year + '): ' + tags.page,
            };
        },
        // 点击引用时执行
        showCite(row) {


            this.dialogCiteVisible = true
            let styles = JSON.stringify(row.citationStyles)
            this.currentCiteStyle = row.citationStyles.bibtex.replaceAll('\'Review\', ', '').replaceAll(', \'Review\'', '')
            this.switchCiteStyle(0)
            this.getCiteValue()
            this.base64Bib = Base64.encode(row.citationStyles.bibtex)
            let tags = bibtexParse.toJSON(this.currentCiteStyle)[0].entryTags;
            this.base64End = Base64.encode('%0 Journal Article\n%T ' + tags.title + '\n%A ' + tags.author +
                '\n%J ' + tags.booktitle + '\n%V ' + tags.volume + '\n%P ' + tags.page + '\n%D ' + tags.year)
            // var sample = bibtexParse.toJSON(row.citationStyles.bibtex);
            // console.log(sample);
            //
            // this.$alert('<pre style="font-family: monospace;white-space: pre;overflow: scroll;padding: 11px 16px;width: 92%;">'+row.citationStyles.bibtex.replaceAll('\n', '<br/>')+'</pre>', '引用', {
            //   dangerouslyUseHTMLString: true
            // });
        },
        // 点击引用时调用事件
        showCite2(cid) {
            this.citeBody = ''
            this.isShowCite2 = true
            this.repeatRequest(cid)
        },
        // 引用模态框内的数据请求函数
        repeatRequest(cid) {
            axios.create({
                // baseURL: 'https://hk.dotaindex.com:18802/', // api 的 base_url
                // baseURL: 'https://gproxy.dotaindex.com/', // api 的 base_url
                // baseURL: 'http://47.251.40.16:8080', // api 的 base_url
                baseURL: 'https://serverp.dotaindex.com/',
                // baseURL: 'http://127.0.0.1:8002', // api 的 base_url
                // baseURL: 'http://47.251.40.16:8080/', // api 的 base_url
                timeout: 30000 // 请求超时时间
            })({
                url: '/api/searchPaper/cite?cid=' + cid,
                method: 'get',
            }).then(res => {
                if (res.data.indexOf("!DOCTYPE") == -1 && res.data.indexOf("Request Error") == -1) {
                    res = res.data
                    res = res.replaceAll('<a', '<a target="_blank"')
                    this.citeBody = res
                    // console.log(this.citeBody);
                } else {
                    // 判断引用模态框是否已经关闭
                    if (this.isShowCite2) {
                        this.repeatRequest(cid);
                    }
                }
            })
        },
        getShortUrl(url) {
            if (!url) return ''
            return url.split('/')[2]
        },
        turnPage(page) {
            // if(page < 1 || page > Math.ceil(this.total / 10)) {
            //     return;
            // }
            // console.log({page});
            this.page = page
            this.jumpTo()
        },
        submitAdvance() {
            this.showAdvance = false

            let q = ''

            if (this.advQuery.pos === 'title') {
                q = 'allintitle: '
            }

            if (this.advQuery.a) {
                //q += ' ' + this.advQuery.a
                //split a by space foreach add to q
                let a = this.advQuery.a.split(' ')
                for (let i = 0; i < a.length; i++) {
                    q += ' ' + a[i]
                }
            }
            if (this.advQuery.c) {
                //split it by space foreach add to q
                let c = this.advQuery.c.split(' ')
                for (let i = 0; i < c.length; i++) {
                    //if more than one add ' OR' to q
                    if (i > 0) {
                        q += ' OR'
                    }

                    q += ' ' + c[i]
                }
            }
            if (this.advQuery.b) {
                q += ' "' + this.advQuery.b + '"'
            }
            if (this.advQuery.d) {
                // q += ' -' + this.advQuery.d
                //split it by space foreach add to q
                let d = this.advQuery.d.split(' ')
                for (let i = 0; i < d.length; i++) {
                    q += ' -' + d[i]
                }
            }
            if (this.advQuery.e) {
                let e = this.advQuery.e.split(' ')
                for (let i = 0; i < e.length; i++) {
                    q += ' author:' + e[i]
                }
            }
            if (this.advQuery.f) {
                let f = this.advQuery.f.split(' ')
                for (let i = 0; i < f.length; i++) {
                    q += ' source:' + f[i]
                }
            }

            let startTime = 0
            let endTime = 0

            if (this.advQuery.yl) {
                startTime = this.advQuery.yl
            }

            if (this.advQuery.yh) {
                endTime = this.advQuery.yh
            }

            this.$router.push({
                path: '/paper_search', query: {
                    q: q,
                    type: this.type,
                    start: startTime,
                    end: endTime,
                }
            })
        },
        enterToQuery() {
            this.drawer = false;
            this.showAdvance = false;
            // window.open('/?v=1#/paper_search?q=' + this.query + '&type=' + this.type, '_blank')
            this.$router.push({ path: '/paper_search', query: { q: this.query, type: this.type, t: Math.random() } })
        },
        updateQuery() {
            this.query = this.$route.query.q
            this.type = this.$route.query.type ? parseInt(this.$route.query.type) : 0
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
            this.startTime = this.$route.query.start || 0
            this.endTime = this.$route.query.end || 0

            this.customTimeForm.start = this.startTime > 0 ? this.startTime : ''
            this.customTimeForm.end = this.endTime > 0 ? this.endTime : ''

            this.lr = this.$route.query.lr || ''
            this.scisbd = this.$route.query.scisbd || ''
            this.sortType = this.$route.query.sortType || 0
            this.loadData()
        },
        jumpTo() {
            this.$router.push({
                path: '/paper_search', query: {
                    q: this.query,
                    type: this.type,
                    page: this.page,
                    start: this.startTime,
                    end: this.endTime,
                    lr: this.lr,
                    scisbd: this.scisbd,
                    sortType: this.sortType
                }
            })
        },
        loadData() {
            if (this.type == 0) {
                this.data = null
                let extendType = this.$route.query.ex;
                if (extendType) {
                    request({
                        url: "api/searchPaper/scite",
                        method: "get",
                        params: {
                            id: this.$route.query.cites,
                            page: this.page,
                        }
                    }).then((r) => {
                        this.data = r;
                        this.total = r.total
                    }).catch(error => {
                        console.log(error);
                    });
                    return
                }


                this.gsHdrTsbDisabled = true
                request({
                    url: "api/searchPaper?size=10&sort=id,desc&start=" + this.startTime + "&end=" + this.endTime + "&q=" + this.query.replaceAll(' ', '+') + "&page=" + this.page,
                    method: "get",
                }).then((r) => {
                    this.data = r;
                    this.total = r.total
                    this.gsHdrTsbDisabled = false
                }).catch(error => {
                    console.log(error);
                    this.gsHdrTsbDisabled = false
                });
            } else {
                clearTimeout(this.lastTimer)
                //if extend type has value, then use extend type data params, otherwise use default data params
                let params = null
                let extendType = this.$route.query.ex;
                if (extendType) {
                    params = {
                        hl: 'zh-CN',
                        start: (this.page - 1) * 10,
                    }

                    //when type is 1,2,3
                    if (extendType == 1) {
                        params.cites = this.$route.query.cites
                    } else if (extendType == 2) {
                        params.q = 'related:' + this.$route.query.related + ':___SG_COM___/'
                    } else if (extendType == 3) {
                        params.cluster = this.$route.query.cluster
                    }
                } else {
                    params = {
                        hl: 'zh-CN',
                        as_ylo: this.startTime > 0 ? this.startTime : '',
                        as_yhi: this.endTime > 0 ? this.endTime : '',
                        q: this.query,
                        start: (this.page - 1) * 10,
                        lr: encodeURIComponent(this.lr),
                        scisbd: this.scisbd,
                    }
                }

                // this.data1 = null
                // data_loading = true
                var retryTime = 0
                var fetchResult = () => {
                    this.data_loading = true
                    this.gsHdrTsbDisabled = true
                    axios.create({
                        // baseURL: 'https://hk.dotaindex.com:18802/', // api 的 base_url
                        // baseURL: 'https://gproxy.dotaindex.com/', // api 的 base_url
                        // baseURL: 'http://47.251.40.16:5560/', // api 的 base_url
                        // baseURL: 'http://47.251.40.16:8080', // api 的 base_url
                        baseURL: 'https://serverp.dotaindex.com/', // api 的 base_url
                        // baseURL: 'http://127.0.0.1:8002', // api 的 base_url
                        timeout: 40000 // 请求超时时间
                    })({
                        url: "api/searchPaper/google",
                        method: "get",
                        params: params,
                    }).then((r) => {
                        // console.log({ r })
                        r = r.data
                        this.data1 = r;
                        this.total = r.total
                        this.data_loading = false
                        this.gsHdrTsbDisabled = false
                        if (r.data != undefined && r.data.length == 0) {
                            if (retryTime++ < 1) {
                                this.data1 = null
                                this.lastTimer = setTimeout(fetchResult, 1000);
                            }
                        }
                    }).catch(error => {
                        // console.log({ error });
                        // console.log(error.response.status);


                        this.data_loading = false
                        this.data1 = []
                        if (error.response.status == 400) {
                            retryTim = 1
                            this.gsHdrTsbDisabled = false
                        } else {

                            if (retryTime++ < 1) {
                                this.data1 = null
                                this.lastTimer = setTimeout(fetchResult, 1000);
                            }

                            this.gsHdrTsbDisabled = false
                        }

                    });
                }
                fetchResult()
            }

        },
        filterTime(start, end) {
            this.startTime = start;
            this.endTime = end;
            this.page = 1
            this.jumpTo()
        },
        isSelected(start, end) {
            return this.startTime === start && this.endTime === end;
        },
        isSelectedCustom() {
            return !(['0', '2019', '2022', '2023'].includes(this.startTime)) || this.endTime !== 0
        },
        filterCustomTime() {
            let start = this.customTimeForm.start
            start = (start === '' ? 0 : parseInt(start))

            let end = this.customTimeForm.end
            end = (end === '' ? 0 : parseInt(end))

            this.filterTime(start, end)
        },
        Hidden() {
            this.Hidden1 = 'none'
        },
        imgClick() {
            window.open('https://sci.justscience.cn/chatgpt')
        },
        getAbstractTranslate(row) {
            request({
                url: `api/searchPaper/translate`,
                method: "post",
                data: {
                    text: row.abstract
                }
            }).then((res) => {
                const abstract_cn = res;
                this.summaryDetail.text = row.abstract;
                this.summaryDetail.text_cn = abstract_cn;
                this.dialogSummaryVisible = true;
            }).catch(error => {
                console.error(error);
            });
        },
        addCollection(row) {
            if (this.global.account == null) {
                this.$message({
                    message: '请先登录',
                    type: 'warning'
                });
                eventBus.$emit('show-login', '');
                return;
            }
            request({
                url: "api/user/ccol",
                method: "post",
                data: {
                    token: this.global.account.token,
                    type: this.type,
                    id: this.id,
                    title: row.title,
                    url: row.url
                }
            }).then((r) => {
                // console.log(r);
                this.isCol = true
            }).catch(error => {
                console.log(error);
            });
        },
    }
}

</script>
<style>
.cite-dialog .el-dialog__title {
    font-weight: bold;
}

.cite-dialog .el-dialog__body {
    padding-top: 10px;
}

#gs_top .el-drawer {
    width: 236px !important;
}
</style>

<style scoped>
#gs_asd {
    width: 80%;
    max-width: 552px;
}

.gs_el_ph #gs_asd {
    width: 100%;
    max-width: 100%;
}

#gs_asd_frm {
    margin-top: -6px;
}

.gs_el_tc #gs_asd_frm {
    margin-top: -8px;
}

.gs_asd_tr {
    clear: both;
}

.gs_el_tc .gs_asd_tr {
    padding: 8px 0;
}

.gs_el_tc .gs_asd_tr:first-child {
    padding-bottom: 0;
}

.gs_asd_dt {
    float: left;
    width: 190px;
    padding: 6px 2px 2px;
}

.gs_el_tc .gs_asd_dt {
    float: none;
    width: auto;
    padding: 0 0 4px 0;
}

.gs_asd_dd {
    margin-left: 194px;
    padding: 2px;
}

.gs_el_tc .gs_asd_dd {
    margin-left: 0;
    padding: 0;
}

.gs_asd_yri .gs_in_txt {
    width: 48px;
}

.gs_el_ph #gs_asd input,
.gs_el_ph #gs_asd label {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.gs_asd_occtr {
    padding: 5px 0;
}

.gs_el_tc .gs_asd_occtr {
    padding: 0;
}

.cite-down-btn {
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 3px;
    text-align: center;
    background-color: #4d90fe;
    padding: 4px 8px;
    margin: 6px;
    color: #ffffff !important;
}

.search-paper-journal-info .el-tag {
    min-width: 80px;
    color: #000000;
    border-color: transparent;
}

.text-wrap {
    display: flex;
    overflow: hidden;
    position: relative;
}

.expand-cb:checked+.text-abstract {
    -webkit-line-clamp: 999 !important;
    /*设置一个足够大的行数就可以了*/
    max-height: none;
}

.expand:hover {
    cursor: pointer;
}

.expand::after {
    content: '[展开]'
}

.expand-cb:checked+.text-abstract .expand::after {
    content: '[收起]'
}


.expand-cb:checked+.text-abstract::after {
    visibility: hidden;
}


.expand-cb:checked+.text-abstract .expand::before {
    visibility: hidden;
    /*在展开状态下隐藏省略号*/
}

.expand-cb {
    display: none;
}

/*.text-abstract{*/
/*    transition: .3s max-height;*/
/*}*/
/*.expand-cb:checked+.text-abstract{*/
/*    max-height: 1000px; !*超出最大行高度就可以了*!*/
/*}*/

.text-abstract {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.text-abstract::before {
    content: '';
    float: right;
    width: 0;
    height: 100%;
    margin-bottom: -20px;
}

.text-wrap .expand {
    color: #0070c0;
    float: right;
    clear: both;
    /*margin-bottom: -24px;*/
}


.text-abstract::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    background: #ffffff;
}
</style>
<style scoped>
* {
    font-family: Arial, sans-serif;
}

#gsAdvertisement {
    padding-top: 50px;
}

#gs_alrt {
    position: fixed;
    bottom: 48px;
    left: 16px;
    max-width: 384px;
    z-index: 1250;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    line-height: 16px;
    color: #e2e2e2;
    background: #333;
    text-align: left;
    border-radius: 3px;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);
    visibility: hidden;
    transform-origin: center;
    transform: scale(0.8, 0.8) translate(0, 100%);
}

#gs_fin {
    bottom: 0;
    left: 0;
    width: 100%;
    white-space: nowrap;
    border-top: 1px solid #e4e4e4;
    background-color: #f2f2f2;
    display: flex
}

.gs_el_ph #gs_alrt {
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: none;
    border-radius: 0;
    box-shadow: none;
    transform: scale(1, 1) translate(0, 100%);
}

#gs_alrt.gs_vis {
    visibility: visible;
    transform: scale(1, 1) translate(0, 0);
}

#gs_alrt.gs_anm {
    transition: transform .067s cubic-bezier(.4, 0, 1, 1), visibility 0s .067s;
}

#gs_alrt.gs_vis.gs_anm {
    transition: transform .067s cubic-bezier(0, 0, .2, 1);
}

.gs_el_ph #gs_alrt.gs_anm {
    transition: transform .084s cubic-bezier(.4, 0, 1, 1), visibility 0s .084s;
}

.gs_el_ph #gs_alrt.gs_vis.gs_anm {
    transition: transform .1s cubic-bezier(0, 0, .2, 1);
}

#gs_alrt_m {
    display: block;
    padding: 16px;
}

#gs_alrt_l {
    display: block;
    padding: 8px;
    margin: 0 8px 0 -8px;
    border-radius: 3px;
    color: #fcc934;
    text-transform: uppercase;
    text-decoration: none;
}

#gs_alrt_l:hover {
    background-color: rgba(255, 255, 255, .05)
}

#gs_alrt_l:active {
    background-color: rgba(255, 255, 255, .1)
}

#gs_alrt_l:empty {
    display: none
}

#gs_alrt_m a {
    padding: 8px 0;
    color: #e2e2e2;
    text-decoration: underline;
}

#gs_alrt_m a:active {
    color: #f6aea9
}

#gs_asd {
    width: 80%;
    max-width: 552px;
}

.gs_el_ph #gs_asd {
    width: 100%;
    max-width: 100%;
}

#gs_asd_frm {
    margin-top: -6px;
}

.gs_el_tc #gs_asd_frm {
    margin-top: -8px;
}

.gs_asd_tr {
    clear: both;
}

.gs_el_tc .gs_asd_tr {
    padding: 8px 0;
}

.gs_el_tc .gs_asd_tr:first-child {
    padding-bottom: 0;
}

.gs_asd_dt {
    float: left;
    width: 190px;
    padding: 6px 2px 2px;
}

.gs_el_tc .gs_asd_dt {
    float: none;
    width: auto;
    padding: 0 0 4px 0;
}

.gs_asd_dd {
    margin-left: 194px;
    padding: 2px;
}

.gs_el_tc .gs_asd_dd {
    margin-left: 0;
    padding: 0;
}

.gs_asd_yri .gs_in_txt {
    width: 48px;
}

.gs_el_ph #gs_asd input,
.gs_el_ph #gs_asd label {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.gs_asd_occtr {
    padding: 5px 0;
}

.gs_el_tc .gs_asd_occtr {
    padding: 0;
}

#gs_cit {
    width: 580px;
    max-width: 80%;
}

.gs_el_ph #gs_cit {
    width: 100%;
    max-width: 100%;
}

#gs_citt table {
    width: 100%;
    margin-top: -8px;
}

#gs_citt td,
#gs_citt th {
    vertical-align: top;
    padding: 8px 0;
}

#gs_citt th {
    text-align: right;
    font-weight: normal;
    color: #777;
    padding-right: 16px;
    white-space: nowrap;
    -webkit-user-select: none;
    user-select: none;
}

#gs_citi,
#cite_citi {
    margin: 16px 0 0 0;
    text-align: center;
}

.gs_el_ph #gs_citi,
.gs_el_ph #cite_citi {
    margin: 16px 0 8px 0;
}

.gs_citi {
    margin-right: 16px;
    white-space: nowrap;
    padding: 7px 0 5px 0;
}

.gs_citi:first-child {
    margin-left: 16px;
}

#gs_md_s,
.gs_md_wnw {
    z-index: 1200;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
}

#gs_md_s {
    background-color: #fff;
    opacity: .5;
}

.gs_el_ta #gs_md_s,
.gs_el_ph #gs_md_s {
    background-color: #666;
}

.gs_md_wnw {
    transition: all 0s .218s;
}

#gs_md_s.gs_vis,
.gs_md_wnw.gs_vis {
    visibility: visible;
    transition: all 0s;
}

.gs_md_wnw>.gs_md_d {
    position: relative;
    margin: 0 auto;
    width: 464px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
    white-space: normal;
}

.gs_el_ta .gs_md_wnw>.gs_md_d,
.gs_el_ph .gs_md_wnw>.gs_md_d {
    box-shadow: 2px 2px 8px rgba(0, 0, 0, .65);
}

.gs_el_ph .gs_md_wnw>.gs_md_d {
    width: 80%;
    max-width: 440px;
}

.gs_el_ph .gs_md_wmw>.gs_md_d {
    width: 100%;
    height: 100%;
    max-width: none;
    border: none;
    box-shadow: none;
    transform: translate(0, 100%);
    transform: translate(0, 100vh);
    transition: transform .27s cubic-bezier(.4, 0, .6, 1), opacity 0s .27s, visibility 0s .27s, max-height 0s .27s;
}

.gs_el_ph .gs_md_wmw>.gs_md_d.gs_vis {
    transform: translate(0, 0);
    transition: transform .3s cubic-bezier(0, 0, .2, 1);
}

.gs_md_wmw>.gs_md_d.gs_abt,
.gs_el_ph .gs_md_wmw>.gs_md_d.gs_abt {
    transition: none;
}

.gs_md_hdr {
    display: flex;
    align-items: center;
    height: 47px;
    border-bottom: 1px solid #e0e0e0;
    border-bottom-color: rgba(0, 0, 0, .12);
    background-color: #f5f5f5;
}

.gs_md_hdr>a,
.gs_md_hdr>a.gs_btn_lrge {
    flex: 0 0 auto;
    width: 41px;
    height: 47px;
}

.gs_el_ph .gs_md_hdr>a {
    margin: 0 2px 0 0;
}

.gs_el_ph a.gs_md_hdr_c {
    margin: 0 0 0 2px;
}

.gs_md_hdr_b {
    margin: 0 41px 0 16px;
}

.gs_el_ph .gs_md_hdr_b {
    margin: 0 16px;
}

.gs_md_hdr_t:empty~.gs_md_hdr_b {
    margin-left: 0;
}

.gs_md_hdr_t {}

.gs_md_hdr_b:empty {
    width: 41px;
    margin: 0;
}

.gs_el_ph .gs_md_hdr_b:empty {
    margin-right: 2px;
}

.gs_md_hdr_b:empty:not(:last-child) {
    display: none;
}

.gs_md_hdr_b>button {
    min-width: 51px;
    height: 33px;
}

.gs_md_hdr_t {
    flex: 1 1 auto;
    font-size: 18px;
    font-weight: normal;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}

.gs_md_bdy {
    overflow-y: auto;
    box-sizing: border-box;
    padding: 24px 41px 0 41px;
}

.gs_md_bdy:after {
    display: block;
    content: "";
    clear: both;
    padding-bottom: 24px;
}

.gs_el_ph .gs_md_bdy {
    padding: 16px 16px 0 16px;
}

.gs_el_ph .gs_md_bdy:after {
    padding-bottom: 16px;
}

.gs_el_ph .gs_md_wmw .gs_md_bdy {
    position: absolute;
    width: 100%;
    top: 48px;
    bottom: 0;
}

.gs_md_lbl {
    display: block;
    font-size: 16px;
    margin: 0 0 16px 0;
    word-wrap: break-word;
}

.gs_md_btns {
    margin: 24px 0 0 0;
    white-space: nowrap;
}

.gs_el_ph .gs_md_btns {
    margin: 16px 0 0 0;
}

.gs_md_btns button {
    margin-right: 16px;
}

.gs_md_btns button:last-child {
    margin-right: 0;
}

.gs_md_prg {
    margin: 24px 0;
    text-align: center;
}

.gs_md_prg .gs_alrt {
    padding: 4px 16px;
}

.gs_md_ldg:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
    opacity: .5;
    z-index: 100;
}

html,
body,
form,
table,
div,
h1,
h2,
h3,
h4,
h5,
h6,
img,
ol,
ul,
li,
button {
    margin: 0;
    padding: 0;
    border: 0;
}

table {
    border-collapse: collapse;
    border-width: 0;
    empty-cells: show;
}

html,
body {
    height: 100%
}

#gs_top {
    position: relative;
    box-sizing: border-box;
    min-height: 100%;
    min-width: 964px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#gs_top>*:not(#x) {
    -webkit-tap-highlight-color: rgba(204, 204, 204, .5);
}

.gs_el_ph #gs_top,
.gs_el_ta #gs_top {
    min-width: 320px;
}

#gs_top.gs_nscl {
    position: fixed;
    width: 100%;
}

body,
td,
input,
button {
    font-size: 13px;
    font-family: Arial, sans-serif;
    line-height: 1.24;
}

body {
    background: #fff;
    color: #222;
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: none;
}

center .gs_ico {
    /*background: none;*/
}

.gs_gray {
    color: #777777
}

.gs_red {
    color: #dd4b39
}

.gs_grn {
    color: #006621
}

.gs_lil {
    font-size: 11px
}

.gs_med {
    font-size: 16px
}

.gs_hlt {
    font-weight: bold;
    color: #dd4b39;
    font-weight: normal;
}

a:link {
    color: #1a0dab;
    text-decoration: none
}

a:visited {
    color: #660099;
    text-decoration: none
}

a:hover,
a:hover .gs_lbl {
    text-decoration: underline
}

a:active,
a:active .gs_lbl,
a .gs_lbl:active {
    color: #d14836
}

.gs_el_tc a:hover,
.gs_el_tc a:hover .gs_lbl {
    text-decoration: none
}

.gs_pfcs a:focus,
.gs_pfcs button:focus,
.gs_pfcs input:focus,
.gs_pfcs label:focus {
    outline: none
}

.gs_a,
.gs_a a:link,
.gs_a a:visited {
    color: #006621
}

.gs_a a:active {
    color: #d14836
}

a.gs_fl:link,
.gs_fl a:link {
    color: #1a0dab
}

a.gs_fl:visited,
.gs_fl a:visited {
    color: #660099
}

a.gs_fl:active,
.gs_fl a:active {
    color: #d14836
}

.gs_fl {
    color: #777777
}

.gs_ctc,
.gs_ctu {
    vertical-align: middle;
    font-size: 13px;
    font-weight: normal
}

.gs_ctc {
    color: #1a0dab
}

a.gs_pda,
.gs_pda a {
    padding: 7px 0 5px 0
}

.gs_alrt {
    background: #f9edbe;
    border: 1px solid #f0c36d;
    padding: 0 16px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
    border-radius: 2px;
}

.gs_spc {
    display: inline-block;
    width: 12px
}

.gs_br {
    width: 0;
    font-size: 0
}

.gs_ibl {
    display: inline-block;
}

.gs_scl:after {
    content: "";
    display: table;
    clear: both;
}

.gs_ind {
    padding-left: 8px;
    text-indent: -8px
}

.gs_ico,
.gs_icm {
    display: inline-block;
    background: no-repeat url(/static/sprite_20161020.png);
    background-position: -23px -161px;
    background-size: 169px;
    width: 21px;
    height: 21px;
}

@media (-webkit-min-device-pixel-ratio: 1.5),
(min-resolution: 144dpi) {

    .gs_ico,
    .gs_icm {
        background-image: url(/static/sprite_20161020x2.png);
    }
}

.gs_el_ta .gs_nta,
.gs_ota,
.gs_el_ph .gs_nph,
.gs_oph {
    display: none
}

.gs_el_ta .gs_ota,
.gs_el_ph .gs_oph {
    display: inline
}

.gs_el_ta div.gs_ota,
.gs_el_ph div.gs_oph {
    display: block
}

.gs_sth_g {
    visibility: hidden;
    max-height: 0;
}

.gs_sth_vis .gs_sth_g {
    max-height: 1000px;
}

.gs_sth_vis .gs_sth_b {
    position: fixed;
    top: 0;
}

@keyframes gs_anm_spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.gs_rimg {
    display: block;
    background-color: #e5e5e5;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    z-index: 1;
}

.gs_rimg>img {
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
}

.gs_in_txtw {
    display: inline-block;
    vertical-align: middle;
}

.gs_in_txtb {
    display: block;
}

.gs_in_txt input {
    color: #000;
    background-color: #fff;
    font-size: 16px;
    box-sizing: border-box;
    height: 29px;
    line-height: 23px;
    border: 1px solid #d9d9d9;
    border-top-color: #c0c0c0;
    padding: 3px 6px 1px 8px;
    border-radius: 1px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

.gs_el_tc .gs_in_txt {
    font-size: 18px;
}

.gs_in_txtb .gs_in_txt {
    width: 100%;
}

.gs_in_txt:hover {
    border-color: #b9b9b9;
    border-top-color: #a0a0a0;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1);
}

.gs_in_txte .gs_in_txt {
    border-color: #dd4b39;
}

.gs_in_txt:focus {
    border-color: #4d90fe;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .3);
}

.gs_in_txt:disabled {
    color: #b8b8b8;
    border-color: #f1f1f1;
    box-shadow: none;
}

.gs_in_txtm .gs_in_txt {
    font-size: 13px;
    height: 24px;
    line-height: 16px;
    padding: 3px 6px;
}

.gs_el_tc .gs_in_txtm .gs_in_txt {
    height: 29px;
    line-height: 21px;
}

.gs_in_txts {
    font-size: 13px;
    line-height: 18px;
    color: #666;
}

.gs_in_txte .gs_in_txts {
    color: #dd4b39;
}

button {
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    font-size: 13px;
    cursor: pointer;
    height: 29px;
    line-height: normal;
    min-width: 72px;
    padding: 0 8px;
    color: #444;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 3px;
    text-align: center;
    background-color: #f5f5f5;
    -webkit-user-select: none;
    user-select: none;
}

button.gs_btn_rnd {
    border-radius: 14px;
    padding: 0 12px;
}

button.gs_btn_rnd.gs_btn_rndci {
    padding-left: 4px;
}

button.gs_btn_lrge {
    height: 41px;
    min-width: 82px;
    padding: 0 9px;
}

button.gs_btn_lrge.gs_btn_rnd {
    border-radius: 20px;
    padding: 0 16px;
}

button.gs_btn_lrge.gs_btn_rnd.gs_btn_rndci {
    padding-left: 10px;
}

button.gs_btn_mini {
    padding: 0;
    border: 0;
}

.gs_el_ph button.gs_btn_mph,
.gs_el_ta button.gs_btn_mta {
    height: 41px;
}

button .gs_wr {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
}

button .gs_wr:before {
    content: "";
    width: 0;
    height: 100%;
}

button .gs_wr:before,
button .gs_ico,
button .gs_rdt,
button .gs_lbl,
button .gs_icm {
    display: inline-block;
    vertical-align: middle;
}

button .gs_wr {
    font-size: 13px;
    text-transform: none;
}

.gs_btn_lrge .gs_wr {
    font-size: 15px;
}

.gs_btn_half,
.gs_el_ta .gs_btn_hta,
.gs_el_ph .gs_btn_hph {
    min-width: 36px;
}

.gs_btn_lrge.gs_btn_half,
.gs_el_ta .gs_btn_lrge.gs_btn_hta,
.gs_el_ph .gs_btn_lrge.gs_btn_hph,
.gs_el_ta .gs_btn_mta,
.gs_el_ph .gs_btn_mph {
    min-width: 41px;
}

.gs_btn_slt {
    border-radius: 3px 0 0 3px;
}

.gs_btn_srt {
    margin-left: -1px;
    border-radius: 0 3px 3px 0;
}

.gs_btn_smd {
    margin-left: -1px;
    border-radius: 0;
}

.box {
    display: flex;
    align-items: baseline;
    margin-top: 5px;
    font-size: 16px;
    align-items: center;
    margin-left: -5px;
}

.box>div {
    margin: 0;
}

/* 二级菜单的样式 */
.subbox {
    margin-left: 20px;
    font-size: 14px;
    font-weight: initial;
}

/* 鼠标经过呈现的样式 */
.subbox:hover,
.box:hover {
    color: #14aab9 !important;
    font-weight: bold;
}

button:hover {
    z-index: 2;
    color: #222;
    border-color: rgba(0, 0, 0, .2);
    background-color: #f8f8f8;
}

button.gs_sel {
    background-color: #dcdcdc;
}

button:active {
    z-index: 2;
    background-color: #f1f1f1;
}

button:focus {
    z-index: 2;
}

button::-moz-focus-inner {
    padding: 0;
    border: 0
}

button:-moz-focusring {
    outline: 1px dotted ButtonText
}

.gs_pfcs button:-moz-focusring {
    outline: none
}

a.gs_in_ib {
    position: relative;
    display: inline-block;
    line-height: 16px;
    padding: 6px 0 7px 0;
    -webkit-user-select: none;
    user-select: none;
}

a.gs_btn_lrge {
    height: 40px;
    padding: 0;
}

a.gs_in_ib .gs_lbl {
    display: inline-block;
    /*width: 100px;*/
    padding-left: 21px;
    color: #222;
}

a.gs_in_ib .gs_lbl:not(:empty) {
    padding-left: 29px;
}

button.gs_in_ib .gs_lbl:not(:empty) {
    padding-left: 4px;
}

a.gs_in_ib:active .gs_lbl,
a.gs_in_ib .gs_lbl:active,
a.gs_in_ib :active~.gs_lbl {
    color: #d14836;
}

.gs_el_ta .gs_btn_hta .gs_lbl,
.gs_el_ph .gs_btn_hph .gs_lbl,
.gs_el_ta .gs_btn_mta .gs_lbl,
.gs_el_ph .gs_btn_mph .gs_lbl,
.gs_el_ta .gs_btn_cta .gs_lbl,
.gs_el_ph .gs_btn_cph .gs_lbl {
    display: none;
}

a.gs_in_ib .gs_ico {
    position: absolute;
    top: 3px;
    left: 0;
}

.gs_in_ib.gs_md_li .gs_ico {
    left: 14px;
}

.gs_el_tc .gs_in_ib.gs_md_li .gs_ico {
    top: 11px;
}

.gs_in_ib.gs_md_li.gs_md_lix .gs_ico {
    top: 10px;
    left: 16px;
}

a.gs_btn_lrge .gs_ico {
    top: 50%;
    left: 50%;
    margin: -10.5px 0 0 -10.5px;
}

.gs_in_ib .gs_ico {
    opacity: .55;
}

.gs_in_ib:hover .gs_ico {
    opacity: .72;
}

.gs_in_ib:active .gs_ico,
.gs_in_ib .gs_ico:active,
.gs_in_ib :active~.gs_ico {
    opacity: 1;
}

.gs_in_ib:disabled .gs_ico,
.gs_in_ib.gs_dis .gs_ico {
    opacity: .28;
}

.gs_in_ib.gs_btn_act .gs_ico,
.gs_in_ib.gs_btn_cre .gs_ico {
    opacity: 1;
}

.gs_btn_act:disabled .gs_ico,
.gs_btn_cre:disabled .gs_ico {
    opacity: .72;
}

.gs_rdt {
    position: relative;
    width: 0;
    height: 21px;
}

.gs_rdt:before {
    content: "";
    position: absolute;
    top: 2px;
    right: 1px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #dd4b39;
}

button.gs_btn_flat {
    border-color: transparent;
    background-color: transparent;
}

button.gs_btn_flat:hover {
    background-color: rgba(0, 0, 0, .05);
}

button.gs_btn_flat:active {
    background-color: rgba(0, 0, 0, .1);
}

button.gs_btn_flat.gs_btn_flact {
    color: #1a0dab;
}

button.gs_btn_act {
    color: #fff;
    -webkit-font-smoothing: antialiased;
    background-color: #4d90fe;
}

button.gs_btn_act:hover {
    color: #fff;
    background-color: #3983fe;
}

button.gs_btn_act.gs_sel {
    background-color: #2f6bcc;
}

button.gs_btn_act:active {
    background-color: #357ae8;
}

button.gs_btn_cre {
    color: #fff;
    -webkit-font-smoothing: antialiased;
    background-color: #d14836;
}

button.gs_btn_cre:hover {
    color: #fff;
    background-color: #c53727;
}

button.gs_btn_cre.gs_sel {
    background-color: #992b1e;
}

html:not(.gs_pfcs) .gs_btn_act:focus:not(:active) {
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .5);
}

button.gs_btn_cre:active {
    background-color: #b0281a;
}

button:disabled,
button:disabled:hover,
button:disabled:active {
    cursor: default;
    color: #b8b8b8;
    border-color: rgba(0, 0, 0, .05);
    background-color: transparent;
    z-index: 0;
}

button.gs_btn_flat:disabled {
    color: #b8b8b8;
    border-color: transparent;
}

button.gs_btn_act:disabled {
    color: #fff;
    background-color: #a6c8ff;
}

button.gs_btn_cre:disabled {
    color: #fff;
    background-color: #e8a49b;
}

a.gs_in_ib.gs_dis {
    cursor: default;
    pointer-events: none
}

a.gs_in_ib.gs_dis .gs_lbl {
    color: #b8b8b8;
    text-decoration: none
}

.gs_ttp {
    position: absolute;
    top: 100%;
    right: 50%;
    z-index: 10;
    pointer-events: none;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s .13s, opacity .13s ease-out;
}

button:hover .gs_ttp,
button:focus .gs_ttp,
a:hover .gs_ttp,
a:focus .gs_ttp {
    transition: visibility 0s .3s, opacity .13s ease-in .3s;
    visibility: visible;
    opacity: 1;
}

.gs_md_tb.gs_sel .gs_ttp {
    transition: none;
    visibility: hidden;
}

.gs_ttp .gs_aro,
.gs_ttp .gs_aru {
    position: absolute;
    top: -2px;
    right: -5px;
    width: 0;
    height: 0;
    line-height: 0;
    font-size: 0;
    border: 5px solid transparent;
    border-top: none;
    border-bottom-color: #2a2a2a;
    z-index: 1;
}

.gs_ttp .gs_aro {
    top: -3px;
    right: -6px;
    border-width: 6px;
    border-top: none;
    border-bottom-color: white;
}

.gs_ttp .gs_txt {
    display: block;
    position: relative;
    top: 2px;
    right: -50%;
    padding: 7px 9px;
    background: #2a2a2a;
    color: white;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    white-space: nowrap;
    border: 1px solid white;
    box-shadow: inset 0 1px 4px rgba(0, 0, 0, .2);
}

.gs_press,
.gs_in_se,
.gs_tan {
    touch-action: none;
}

.gs_in_se .gs_lbl:not(:empty) {
    padding-right: 14px;
}

.gs_in_se .gs_icm {
    position: absolute;
    top: 50%;
    margin-top: -5.5px;
    right: 0;
    width: 7px;
    height: 11px;
    background-position: -21px -88px;
    opacity: .55;
}

.gs_in_se:hover .gs_icm {
    opacity: .72;
}

.gs_in_se:active .gs_icm {
    opacity: 1;
}

.gs_in_se:disabled .gs_icm {
    opacity: .28;
}

.gs_el_ta .gs_btn_hta .gs_icm,
.gs_el_ph .gs_btn_hph .gs_icm,
.gs_el_ta .gs_btn_mta .gs_icm,
.gs_el_ph .gs_btn_mph .gs_icm,
.gs_el_ta .gs_btn_cta .gs_icm,
.gs_el_ph .gs_btn_cph .gs_icm {
    display: none;
}

.gs_btn_mnu .gs_icm {
    margin-top: -3.5px;
    height: 7px;
    background-position: 0 -110px;
}

.gs_in_se.gs_btn_act .gs_icm,
.gs_in_se.gs_btn_cre .gs_icm {
    margin-top: -3.5px;
    height: 7px;
    background-position: -42px -44px;
    opacity: 1;
}

.gs_btn_act:disabled .gs_icm,
.gs_btn_cre:disabled .gs_icm {
    opacity: .72;
}

button.gs_btnG .gs_ico {
    width: 21px;
    height: 21px;
    background-position: -92px -253px;
}

.gs_md_d {
    text-transform: none;
    white-space: nowrap;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #ccc;
    border-color: rgba(0, 0, 0, .2);
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
    z-index: 1100;
    text-align: left;
    visibility: hidden;
    max-height: 0;
    margin-top: -1000px;
    opacity: 0;
    transition: opacity .13s, visibility 0s .13s, max-height 0s .13s, margin-top 0s .13s;
}

.gs_md_d.gs_vis {
    visibility: visible;
    max-height: 10000px;
    margin-top: 0;
    opacity: 1;
    transition: all 0s;
}

.gs_el_tc .gs_md_d {
    transform-origin: 100% 0;
    transform: scale(1, 0);
    transition: opacity .218s ease-out, transform 0s .218s, visibility 0s .218s, max-height 0s .218s, margin-top 0s .218s;
}

.gs_el_ios .gs_md_d {
    -webkit-backface-visibility: hidden;
}

.gs_el_tc .gs_md_d.gs_ttzi {
    transform-origin: 50% 50%;
    transform: scale(0, 0);
}

.gs_el_tc .gs_md_d.gs_ttzr {
    transform: scale(0, 0);
}

.gs_el_tc .gs_md_d.gs_vis {
    transform: scale(1, 1);
    transition: transform .218s ease-out;
}

.gs_md_r {
    position: relative;
    display: inline-block;
}

.gs_md_rmb>.gs_md_d {
    top: 29px
}

.gs_md_rmbl>.gs_md_d {
    top: 41px
}

.gs_md_ul {
    list-style-type: none;
    word-wrap: break-word;
    display: inline-block;
    vertical-align: top;
}

.gs_md_ul.gs_md_ul_tb {
    display: block;
}

.gs_md_li,
.gs_in_cb.gs_md_li,
.gs_md_li:link,
.gs_md_li:visited {
    display: block;
    padding: 6px 44px 6px 16px;
    font-size: 13px;
    line-height: 16px;
    color: #222;
    cursor: pointer;
    text-decoration: none;
    position: relative;
    z-index: 0;
}

a.gs_md_li:hover .gs_lbl,
a.gs_md_li:active .gs_lbl {
    text-decoration: none
}

.gs_el_tc .gs_md_li {
    padding-top: 14px;
    padding-bottom: 10px;
}

.gs_md_li.gs_md_lix {
    font-size: 16px;
    line-height: 20px;
    padding: 12px 16px 8px 16px;
}

.gs_md_li:before {
    content: "";
    background-color: #f1f1f1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity .13s;
    z-index: -1;
}

.gs_md_li:hover:before,
.gs_md_li:focus:before {
    opacity: 1;
    transition: all 0s;
}

a.gs_in_ib.gs_md_li .gs_lbl {
    color: #222
}

a.gs_in_ib.gs_md_li.gs_in_gray .gs_lbl {
    color: #444
}

.gs_md_li:active:before {
    background-color: #ddd
}

.gs_md_li.gs_sel,
a.gs_in_ib.gs_md_li.gs_sel .gs_lbl {
    color: #d14836
}

.gs_md_d:focus,
.gs_md_li:focus {
    outline: none
}

a.gs_md_lix .gs_lbl,
a.gs_md_lix .gs_lbl:not(:empty) {
    padding: 0 0 0 40px;
}

a.gs_in_cb:link,
a.gs_in_cb:visited,
a.gs_in_cb:active,
a.gs_in_cb:hover {
    cursor: pointer;
    color: #222;
    text-decoration: none;
}

.gs_in_cb,
.gs_in_ra {
    position: relative;
    line-height: 16px;
    display: inline-block;
    -webkit-user-select: none;
    user-select: none;
}

.gs_in_cb.gs_md_li {
    padding: 6px 44px 6px 16px;
}

.gs_in_cb input,
.gs_in_ra input {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 15px;
    height: 15px;
    margin: 0;
    padding: 0;
    opacity: 0;
    z-index: 2;
}

.gs_in_ra input {
    top: 0;
    left: 0
}

.gs_el_tc .gs_in_cb input {
    top: 9px
}

.gs_el_tc .gs_in_ra input {
    top: 8px
}

.gs_in_cb.gs_in_cbj input {
    top: 15px;
    left: 15px
}

.gs_in_cb label,
.gs_in_cb .gs_lbl,
.gs_in_ra label {
    display: inline-block;
    padding-left: 21px;
    min-height: 16px;
}

.gs_in_cb label:empty:before,
.gs_in_cb .gs_lbl:empty:before,
.gs_in_ra label:empty:before {
    content: "\200b";
}

.gs_el_tc .gs_in_cb label,
.gs_el_tc .gs_in_cb .gs_lbl,
.gs_el_tc .gs_in_ra label {
    padding-top: 8px;
    padding-bottom: 5px;
}

.gs_in_cb.gs_in_cbj label,
.gs_in_cb.gs_in_cbj .gs_lbl {
    padding: 13px 0 12px 41px;
}

.gs_in_cbb,
.gs_in_cbb label,
.gs_in_cbb .gs_lbl {
    display: block;
}

.gs_in_cb .gs_cbx,
.gs_in_ra .gs_cbx {
    position: absolute
}

.gs_in_cb .gs_cbx {
    top: 2px;
    left: 2px;
    width: 11px;
    height: 11px;
    border: 1px solid #c6c6c6;
    border-radius: 1px;
}

.gs_md_li .gs_cbx {
    top: 8px;
    left: 18px
}

.gs_el_tc .gs_in_cb .gs_cbx {
    top: 10px
}

.gs_el_tc .gs_md_li .gs_cbx {
    top: 16px
}

.gs_in_cb.gs_in_cbj .gs_cbx {
    top: 15px;
    left: 15px
}

.gs_el_tc .gs_in_ra .gs_cbx {
    top: 8px
}

.gs_in_ra .gs_cbx {
    top: 0;
    left: 0;
    border: 1px solid #c6c6c6;
    width: 13px;
    height: 13px;
    border-radius: 7px;
}

.gs_in_cb:hover .gs_cbx,
.gs_in_ra:hover .gs_cbx {
    border-color: #666;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .1);
}

button.gs_in_cb:hover .gs_cbx {
    border-color: #c6c6c6;
}

.gs_in_cb :focus~label,
.gs_in_ra :focus~label {
    outline: 1px dotted #222;
    outline: auto -webkit-focus-ring-color;
}

.gs_pfcs .gs_in_cb :focus~label,
.gs_pfcs .gs_in_ra :focus~label {
    outline: none;
}

.gs_in_cb:active .gs_cbx,
.gs_in_ra:active .gs_cbx,
.gs_in_cb .gs_cbx:active,
.gs_in_ra .gs_cbx:active,
.gs_in_cb :active~.gs_cbx,
.gs_in_ra :active~.gs_cbx {
    border-color: #666;
    background-color: #ebebeb;
}

button.gs_in_cb:active .gs_cbx {
    border-color: #a6a6a6;
}

.gs_in_cb :disabled~.gs_cbx,
.gs_in_ra :disabled~.gs_cbx,
button.gs_in_cb:disabled .gs_cbx {
    border-color: #f1f1f1;
    box-shadow: none;
}

.gs_in_cb :disabled~label,
.gs_in_ra :disabled~label {
    color: #b8b8b8;
}

.gs_in_cb.gs_err .gs_cbx {
    border-color: #eda29b;
}

.gs_in_cb .gs_chk,
.gs_in_ra .gs_chk {
    position: absolute;
    z-index: 1;
    top: -3px;
    left: -2px;
    width: 21px;
    height: 21px;
}

.gs_md_li .gs_chk {
    top: 3px;
    left: 14px
}

.gs_el_tc .gs_in_cb .gs_chk {
    top: 5px
}

.gs_el_tc .gs_md_li .gs_chk {
    top: 11px
}

.gs_in_cb.gs_in_cbj .gs_chk {
    top: 10px;
    left: 11px
}

.gs_in_ra .gs_chk {
    top: 4px;
    left: 4px;
    width: 7px;
    height: 7px;
    border-radius: 4px;
}

.gs_el_tc .gs_in_ra .gs_chk {
    top: 12px
}

.gs_in_cb input:checked~.gs_chk,
.gs_in_cb.gs_sel .gs_chk {
    background: no-repeat url(/static/sprite_20161020.png) -69px -67px;
    opacity: .62;
}

.gs_in_ra input:checked~.gs_chk {
    background-color: #666
}

.gs_in_cb.gs_par .gs_chk {
    background: no-repeat url(/static/sprite_20161020.png) -21px -44px;
    opacity: .55;
}

@media (-webkit-min-device-pixel-ratio: 1.5),
(min-resolution: 144dpi) {

    .gs_in_cb input:checked~.gs_chk,
    .gs_in_cb.gs_sel .gs_chk,
    .gs_in_cb.gs_par .gs_chk {
        background-image: url(/static/sprite_20161020x2.png);
        background-size: 169px;
    }
}

.gs_in_cb input:checked:disabled~.gs_chk {
    opacity: .22
}

.gs_in_ra input:checked:disabled~.gs_chk {
    background-color: #f1f1f1
}

.gs_md_ac {
    position: absolute;
    top: 28px;
    left: 0;
    right: 0;
    z-index: 1100;
    white-space: normal;
    display: none;
    pointer-events: none;
}

.gs_md_ac[dir="ltr"] {
    text-align: left;
}

.gs_md_ac[dir="rtl"] {
    text-align: right;
}

.gs_md_ac ul {
    list-style-type: none;
    word-wrap: break-word;
    line-height: 1.24;
    border: 1px solid #e5e5e5;
    border-color: rgba(0, 0, 0, .2);
    background: #fff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, .2);
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    pointer-events: auto;
}

.gs_md_acp {
    display: flex;
    line-height: 0;
}

.gs_md_acp .gs_md_acs,
.gs_md_acp ul {
    max-width: 100%;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
}

.gs_md_acs {
    visibility: hidden;
    white-space: pre;
    height: 0;
    min-width: 0%;
    flex: 0 1 auto;
    font-size: 16px;
}

.gs_el_tc .gs_md_acs {
    font-size: 18px;
}

.gs_md_acp ul {
    white-space: nowrap;
    flex: 0 0 auto;
}

.gs_md_ac li {
    position: relative;
    padding: 2px 8px;
    font-size: 16px;
    line-height: 20px;
    color: #222;
    background-color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
}

.gs_md_ac li.gs_sel {
    color: #000;
    background-color: #c6dafc;
}

.gs_md_ac li:active {
    background-color: #e8f0fe;
}

.gs_el_ios .gs_md_ac li:active {
    background-color: #fff;
}

.gs_md_ac b {
    font-weight: normal;
}

.gs_md_ac li.gs_md_ac_lh,
.gs_md_ac li.gs_md_ac_lh b {
    color: #660099;
}

.gs_el_tc .gs_md_ac li {
    padding: 11px 8px 9px 8px;
    font-size: 18px;
    border-top: 1px solid #e5e5e5;
}

.gs_el_tc .gs_md_ac li:first-child {
    border-top: none;
}

.gs_md_ac[dir="ltr"] li.gs_md_ac_lh {
    padding-right: 29px;
}

.gs_md_ac[dir="rtl"] li.gs_md_ac_lh {
    padding-left: 29px;
}

.gs_el_tc .gs_md_ac[dir="ltr"] li.gs_md_ac_lh {
    padding-right: 49px;
}

.gs_el_tc .gs_md_ac[dir="rtl"] li.gs_md_ac_lh {
    padding-left: 49px;
}

.gs_md_ac_lh .gs_ico_X {
    position: absolute;
    top: 0;
}

.gs_md_ac[dir="ltr"] .gs_md_ac_lh .gs_ico_X {
    right: 0;
}

.gs_md_ac[dir="rtl"] .gs_md_ac_lh .gs_ico_X {
    left: 0;
}

.gs_el_tc #gs_top .gs_md_ac .gs_md_ac_lh .gs_ico_Xt {
    padding: 10px;
}

.gs_md_ac_lh .gs_ico_X:hover {
    background-color: #eee;
}

.gs_ico_x {
    background-position: -113px -22px;
    opacity: .55;
}

.gs_ico_x:hover {
    opacity: .72;
}

.gs_ico_x:active {
    opacity: 1;
}

.gs_ico_X {
    background-position: -71px 0;
    opacity: .55;
}

.gs_ico_X:hover {
    opacity: .72;
}

.gs_ico_X:active {
    opacity: 1;
}

.gs_el_tc .gs_ico_Xt {
    background-origin: content-box;
    background-clip: content-box;
    padding: 10px 6px 10px 14px;
}

.gs_ico_P {
    background-position: 0 0;
    opacity: .55;
}

.gs_ico_P:hover {
    opacity: .72;
}

.gs_ico_P:active {
    opacity: 1;
}

.gs_btnP .gs_ico {
    background-position: -21px 0;
}

.gs_btnC .gs_ico {
    background-position: 0 -66px;
}

.gs_btnL .gs_ico {
    background-position: -92px -44px;
}

.gs_ico_LB {
    background-position: -50px -44px;
    height: 16px;
}

.gs_btnJ .gs_ico {
    background-position: -92px -22px;
}

.gs_btnM .gs_ico {
    background-position: -92px 0;
}

.gs_btnMW .gs_ico {
    background-position: -21px -22px;
}

.gs_btnSB .gs_ico {
    background-position: 0 -44px;
}

.gs_btnTSB .gs_ico {
    background-position: -115px -253px;
}

.gs_btnPL .gs_ico {
    background-position: -148px -66px;
}

.gs_btnPR .gs_ico {
    background-position: -21px -66px;
}

.gs_btnPLW .gs_ico {
    background-position: -0 -230px;
}

.gs_btnPRW .gs_ico {
    background-position: -23px -230px;
}

.gs_btnZI .gs_ico {
    background-position: -148px -22px;
}

.gs_btnZO .gs_ico {
    background-position: -127px -44px;
}

.gs_btnDE .gs_ico {
    background-position: -134px 0;
}

.gs_btnFI .gs_ico {
    background-position: -50px -66px;
}

.gs_btnAD .gs_ico {
    background-position: -141px -88px;
    opacity: .55;
}

.gs_btnAD:hover .gs_ico {
    opacity: .72;
}

.gs_btnAD:active .gs_ico,
.gs_btnAD .gs_ico:active,
.gs_btnAD :active~.gs_ico {
    opacity: 1;
}

.gs_btnBA .gs_ico {
    background-position: -50px -22px;
}

.gs_btnBL .gs_ico {
    background-position: 0 -22px;
}

.gs_btnBLD .gs_ico {
    background-position: -23px -184px;
}

.gs_btnADD .gs_ico {
    background-position: -92px -66px;
}

.gs_btnMRG .gs_ico {
    background-position: -113px 0;
}

.gs_btnLBL .gs_ico {
    background-position: 0 -161px;
}

.gs_btnCNCL .gs_ico {
    background-position: -71px 0;
}

.gs_btnDWL .gs_ico {
    background-position: -28px -88px;
}

.gs_btnMNU .gs_ico {
    background-position: 0 -88px;
}

.gs_btnMNT .gs_ico {
    background-position: -46px -161px;
}

.gs_btnALT .gs_ico {
    background-position: -92px -161px;
}

.gs_btnART .gs_ico {
    background-position: -115px -161px;
}

.gs_btnGSL .gs_ico {
    background-position: -69px -161px;
}

.gs_btnCLS .gs_ico {
    background-position: -138px -161px;
}

.gs_btnXBLU .gs_ico {
    background-position: -138px -253px;
}

.gs_btnSSB .gs_ico {
    background-position: 0 -276px;
}

.gs_btnSSW .gs_ico {
    background-position: -23px -276px;
}

.gs_btnFLT .gs_ico {
    background-position: 0 -184px;
}

.gs_btnXT .gs_ico {
    background-position: -46px -184px;
}

.gs_btnPD .gs_ico {
    background-position: -69px -184px;
}

.gs_btnPU .gs_ico {
    background-position: -92px -276px;
}

.gs_btnCP .gs_ico {
    background-position: -92px -184px;
}

.gs_btnTP .gs_ico {
    background-position: -138px -184px;
}

.gs_btnML .gs_ico {
    background-position: -115px -276px;
}

.gs_btnCHK .gs_ico {
    background-position: -71px -66px;
}

.gs_btnDNB .gs_ico {
    background-position: -115px -230px;
}

.gs_btnDNW .gs_ico {
    background-position: 0 -207px;
}

.gs_btnACA .gs_ico {
    background-position: -23px -207px;
}

.gs_btnAPT .gs_ico {
    background-position: -46px -207px;
}

.gs_btnAPTW .gs_ico {
    background-position: -92px -230px;
}

.gs_btnAFL .gs_ico {
    background-position: -69px -207px;
}

.gs_btnAN .gs_ico {
    background-position: -46px -276px;
}

.gs_btnAI .gs_ico {
    background-position: -69px -276px;
}

.gs_btnPBL .gs_ico {
    background-position: -92px -207px;
}

.gs_btnUCT .gs_ico {
    background-position: -115px -207px;
}

.gs_btnVRF .gs_ico {
    background-position: -138px -207px;
}

.gs_btnLSI .gs_ico {
    background-position: -46px -230px;
}

.gs_btnLSG .gs_ico {
    background-position: -69px -230px;
}

.gs_btnMOR .gs_ico {
    background-position: -23px -253px;
}

.gs_btnADV .gs_ico {
    background-position: -46px -253px;
}

.gs_btnPRO .gs_ico {
    background-position: -69px -253px;
}

.gs_ico_nav_previous {
    background-position: 0 -119px;
    width: 53px;
    height: 40px;
}

.gs_ico_nav_first {
    background-position: -25px -119px;
    width: 28px;
    height: 40px;
}

.gs_ico_nav_current {
    background-position: -53px -119px;
    width: 20px;
    height: 40px;
}

.gs_ico_nav_page {
    background-position: -73px -119px;
    width: 20px;
    height: 40px;
}

.gs_ico_nav_next {
    background-position: -93px -119px;
    width: 71px;
    height: 40px;
}

.gs_ico_nav_last {
    background-position: -93px -119px;
    width: 45px;
    height: 40px;
}

.gs_ico_star {
    background-position: -71px -44px;
    width: 13px;
    height: 13px;
}

.gs_btnPLSW .gs_ico {
    background-position: -138px -230px;
}

.gs_btnPDF .gs_ico {
    background-position: 0 -253px;
}

#gs_hdr_drs,
#gs_hdr_drw {
    /*display: none;*/
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1200;
    /*visibility: hidden;*/
}

#gs_hdr_drs {
    opacity: 0;
    background-color: #fff;
    transition: opacity .15s, visibility 0s .15s;
}

.gs_el_ta #gs_hdr_drs,
.gs_el_ph #gs_hdr_drs {
    background-color: #666;
}

#gs_hdr_drs.gs_vis {
    visibility: visible;
    opacity: .5;
    transition: opacity .15s, visibility 0s;
}

.gs_el_tc #gs_hdr_drs {
    transition: opacity .218s, visibility 0s .218s;
}

.gs_el_tc #gs_hdr_drs.gs_vis {
    transition: opacity .218s, visibility 0s;
}

#gs_hdr_drw {
    overflow: auto;
    width: 236px;
    background-color: #fff;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, .15);
    outline: none;
    transform: translate(-100%, 0);
    transition: transform .15s ease-in-out, visibility 0s .15s;
}

#gs_hdr_drw.gs_vis {
    visibility: visible;
    transform: translate(0, 0);
    transition: transform .15s ease-in-out, visibility 0s;
}

.gs_el_tc #gs_hdr_drw {
    transition: transform .3s cubic-bezier(.4, 0, .6, 1), visibility 0s .3s;
}

.gs_el_tc #gs_hdr_drw.gs_vis {
    transition: transform .225s cubic-bezier(0, 0, .2, 1), visibility 0s;
}

#gs_hdr_drw.gs_abt,
.gs_el_tc #gs_hdr_drw.gs_abt {
    transition: none;
}

#gs_hdr_drw_in {
    position: relative;
    box-sizing: border-box;
    min-height: 100%;
    padding: 0 0 8px 0;
}

.gs_el_ta #gs_hdr_drw_in,
.gs_el_ph #gs_hdr_drw_in {
    padding: 0 0 65px 0;
}

#gs_hdr_drw_top {
    position: relative;
    height: 63px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 8px;
}

.gs_el_ta #gs_hdr_drw_top,
.gs_el_ph #gs_hdr_drw_top {
    height: 57px;
}

#gs_hdr_drw_mnu,
#gs_hdr_drw_lgo {
    position: absolute;
    top: 0;
    height: 100%;
}

#gs_hdr_drw_mnu {
    left: 0;
    width: 55px;
}

#gs_hdr_drw_lgo {
    left: 56px;
}

.gs_hdr_drw_sec:before {
    display: block;
    content: " ";
    height: 0;
    border-bottom: 1px solid #e5e5e5;
    margin: 8px 0;
}

.gs_hdr_drw_sec:first-child:before {
    display: none;
}

#gs_hdr_drw_bot {
    display: none;
}

.gs_el_ta #gs_hdr_drw_bot,
.gs_el_ph #gs_hdr_drw_bot {
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 65px;
}

#gs_hdr_drw_bot .gs_md_li:before {
    opacity: 0;
}

#gs_hdr_drw_bot .gs_hdr_pp {
    display: block;
    position: absolute;
    bottom: 14px;
    left: 15px;
    pointer-events: none;
}

#gs_hdr_drw_bot .gs_lbl {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#gs_hdr {
    position: relative;
    height: 63px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
}

.gs_el_ta #gs_hdr,
.gs_el_ph #gs_hdr {
    height: 57px;
}

#gs_hdr_mnu,
#gs_hdr_bck,
#gs_hdr_lgo,
#gs_hdr_lgt,
#gs_hdr_md,
#gs_hdr_sre,
#gs_hdr_act {
    display: inline-block;
    vertical-align: top;
    position: relative;
    height: 100%;
    flex: 0 0 auto;
}

#gs_hdr_md {
    flex: 1 1 auto;
}

#gs_hdr_md a {
    position: absolute;
    left: 750px;
    bottom: 0px;
}

#gs_hdr .gs_hdr_mbo,
#gs_hdr .gs_hdr_mbo,
.gs_el_ta #gs_hdr .gs_hdr_dso,
.gs_el_ph #gs_hdr .gs_hdr_dso {
    display: none;
}

.gs_el_ta #gs_hdr .gs_hdr_mbo,
.gs_el_ph #gs_hdr .gs_hdr_mbo {
    display: inline-block;
}

#gs_hdr_mnu,
#gs_hdr_bck,
#gs_hdr_sre {
    width: 55px;
    margin-right: 1px;
}

#gs_hdr_lgo,
#gs_hdr_drw_lgo {
    width: 158px;
    background: no-repeat url('/intl/zh-CN/scholar/images/1x/scholar_logo_24dp.png') 0% 50%;
    background-size: 158px;
}

@media (-webkit-min-device-pixel-ratio: 1.5),
(min-resolution: 144dpi) {

    #gs_hdr_lgo,
    #gs_hdr_drw_lgo {
        background-image: url('/intl/zh-CN/scholar/images/2x/scholar_logo_24dp.png');
    }
}

#gs_hdr_lgo {
    margin-right: 30px;
}

.gs_el_ph #gs_hdr_lgo {
    margin-right: 0;
}

#gs_hdr_lgt {
    min-width: 172px;
    margin-right: 16px;
}

.gs_el_sm #gs_hdr_lgt:empty {
    min-width: 60px;
}

#gs_hdr_md {
    margin-right: 16px;
    min-width: 1px;
}

#gs_hdr_lgt,
#gs_hdr_md h1 {
    padding: 19px 0 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 20px;
    line-height: 25px;
    font-weight: normal;
    color: #666;
    max-width: 100%;
    text-align: left;
}

.gs_el_ta #gs_hdr_md h1,
.gs_el_ph #gs_hdr_md h1 {
    padding: 16px 0 0 0;
}

#gs_hdr_srch {
    /* padding: 14px 0 0 0; */
    /* max-width: 400px; */
}

.gs_el_ta #gs_hdr_srch,
.gs_el_ph #gs_hdr_srch {
    padding: 10px 0 0 0;
    max-width: none;
}

#gs_hdr_frm {
    position: relative;
    padding-right: 39px;
}

#gs_hdr_tsi {
    height: 38px;
    border-radius: 2px 0 0 2px;
}

#gs_hdr_tsi::-ms-clear {
    display: none;
}

#gs_hdr_tsc {
    display: none;
    position: absolute;
    top: 3px;
    right: 41px;
    width: 21px;
    height: 21px;
    padding: 6px 10px 7px 10px;
}

.gs_in_acw[dir="rtl"]~#gs_hdr_tsc {
    right: auto;
    left: 1px;
}

#gs_hdr_tsb {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 38px;
    border-radius: 0 2px 2px 0;
}

#gs_hdr_frm_ac {
    top: 37px;
    right: 40px;
}

.gs_el_ph #gs_hdr_frm_ac {
    right: 0;
}

.gs_el_ph .gs_hdr_ifc #gs_hdr_mnu,
.gs_el_ph .gs_hdr_ifc #gs_hdr_bck,
.gs_hdr_src #gs_hdr_srch,
.gs_hdr_src #gs_hdr_lgt,
.gs_hdr_srx #gs_hdr_sre,
.gs_hdr_srx #gs_hdr_md h1,
.gs_hdr_srx #gs_hdr_md h1.gs_hdr_mbo,
.gs_hdr_srx #gs_hdr_md h1.gs_hdr_dso,
.gs_el_ta .gs_hdr_srx #gs_hdr_lgo,
.gs_el_ph .gs_hdr_srx #gs_hdr_lgo,
.gs_el_ph .gs_hdr_srx #gs_hdr_mnu,
.gs_el_ph .gs_hdr_srx #gs_hdr_bck {
    display: none;
}

.gs_el_ph .gs_hdr_ifc #gs_hdr_md,
.gs_el_ph .gs_hdr_srx #gs_hdr_md {
    margin-left: 16px;
}

.gs_el_tc .gs_hdr_tsc #gs_hdr_tsi[dir="ltr"] {
    padding-right: 41px;
}

.gs_el_tc .gs_hdr_tsc #gs_hdr_tsi[dir="rtl"] {
    padding-left: 41px;
}

.gs_el_tc .gs_hdr_tsc .gs_in_acw~#gs_hdr_tsc {
    display: block;
}

#gs_hdr_act {
    min-width: 64px;
    max-width: 200px;
    text-align: right;
    float: right;
}

.gs_el_ta #gs_hdr_act,
.gs_el_ph #gs_hdr_act {
    display: none;
}

#gs_hdr_act_i,
#gs_hdr_act_s {
    display: inline-block;
    padding: 23px 24px 23px 16px;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #444;
}

#gs_hdr_act_s {
    font-size: 15px;
}

.gs_el_sm #gs_hdr_act_i,
.gs_el_sm #gs_hdr_act_s {
    padding: 23px 16px;
}

.gs_el_ta #gs_hdr_act_i,
.gs_el_ta #gs_hdr_act_s,
.gs_el_ph #gs_hdr_act_i,
.gs_el_ph #gs_hdr_act_s {
    padding: 20px 16px;
}

#gs_hdr_act_i:active,
#gs_hdr_act_s:active {
    color: #d14836;
}

#gs_hdr_act_i,
.gs_el_sm #gs_hdr_act_i {
    padding-top: 15px;
    padding-bottom: 16px;
}

.gs_el_ta #gs_hdr_act_i,
.gs_el_ph #gs_hdr_act_i {
    padding-top: 12px;
    padding-bottom: 13px;
}

#gs_hdr_act_i .gs_hdr_pp {
    vertical-align: top;
}

#gs_hdr_act_d {
    top: 63px;
    left: auto;
    right: 24px;
    min-width: 288px;
    max-width: 400px;
}

.gs_el_sm #gs_hdr_act_d {
    right: 16px;
}

.gs_el_ta #gs_hdr_act_d {
    top: 57px;
}

.gs_el_ph #gs_hdr_act_d {
    top: 57px;
    min-width: 280px;
    max-width: 280px;
    max-width: 90vw;
}

/* Account dialog body. */
#gs_hdr_act_aw,
#gs_hdr_act_ap,
.gs_hdr_act_am,
#gs_hdr_act_ab {
    display: block;
    padding: 10px 20px;
    word-wrap: break-word;
    white-space: normal;
}

#gs_hdr_act_aw {
    background-color: #fef9db;
    font-size: 11px;
}

#gs_hdr_act_ap,
.gs_hdr_act_am {
    border-bottom: 1px solid #ccc;
}

#gs_hdr_act_ap {
    padding: 20px;
}

.gs_el_ph #gs_hdr_act_ap {
    padding: 10px;
}

#gs_hdr_act_apb {
    margin-top: 12px;
}

#gs_hdr_act_aa:link,
#gs_hdr_act_aa:visited {
    float: right;
    margin-left: 8px;
    color: #1a0dab;
}

#gs_hdr_act_aa:active {
    color: #d14836
}

.gs_hdr_act_am:link,
.gs_hdr_act_am:visited {
    color: #222;
    text-decoration: none;
    background: #fbfbfb;
}

.gs_hdr_act_am:hover,
.gs_hdr_act_am:focus {
    background: #f1f1f1;
}

.gs_hdr_act_am:active {
    background: #eee;
}

#gs_hdr_act_ab {
    background: #fbfbfb;
    padding: 10px 0;
    display: table;
    width: 100%;
    white-space: nowrap;
}

#gs_hdr_act_aba,
#gs_hdr_act_abs {
    display: table-cell;
    padding: 0 20px;
}

#gs_hdr_act_abs {
    text-align: right;
}

.gs_el_ph #gs_hdr_act_aba,
.gs_el_ph #gs_hdr_act_abs {
    display: block;
    padding: 10px;
    text-align: center;
}

.gs_el_ph #gs_hdr_act_aba button,
.gs_el_ph #gs_hdr_act_abs button {
    width: 100%;
}

#gs_hdr_act_a1,
#gs_hdr_act_a2 {
    position: absolute;
    top: -9px;
    right: 7.5px;
    width: 0;
    height: 0;
    z-index: 1;
    border: 8.5px solid transparent;
    border-top: none;
    border-bottom-color: #333;
    border-bottom-color: rgba(0, 0, 0, .2);
}

#gs_hdr_act_a2 {
    top: -8px;
    border-bottom-color: #fff;
}

.gs_hdr_act_mw #gs_hdr_act_a2 {
    border-bottom-color: #fef9db;
}

.gs_hdr_pp {
    border-radius: 50%;
    overflow: hidden;
}

#gs_hdr_act_ap .gs_hdr_pp,
.gs_hdr_act_am .gs_hdr_pp {
    float: left;
}

#gs_hdr_act_ap .gs_hdr_pm {
    margin-left: 116px;
}

.gs_hdr_act_am .gs_hdr_pm {
    margin: 6px 0 0 58px;
}

#gs_ab {
    position: relative;
    height: 41px;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    white-space: nowrap;
    background-color: #fff;
    z-index: 1000;
}

.gs_el_ta #gs_ab.gs_nta,
.gs_el_ph #gs_ab.gs_nph {
    display: none;
}

#gs_ab_g {
    height: 42px;
}

.gs_sth_vis #gs_ab {
    position: fixed;
}

#gs_ab_ico,
#gs_ab_ttl,
#gs_ab_md,
#gs_ab_btns {
    display: inline-block;
    vertical-align: top;
    position: relative;
    height: 100%;
    flex: 0 0 auto;
}

.gs_el_ph #gs_ab_md {
    display: block;
}

#gs_ab_ico {
    width: 55px;
    margin-right: 1px;
}

.gs_el_sm #gs_ab_ico {
    width: 15px;
    visibility: hidden;
}

.gs_el_ta #gs_ab_ico,
.gs_el_ph #gs_ab_ico {
    width: 55px;
    visibility: visible;
}

#gs_ab_ico .gs_ico {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -10.5px 0 0 -10.5px;
}

#gs_ab_ttl {
    min-width: 180px;
    padding-right: 8px;
}

.gs_el_sm #gs_ab_ttl {
    min-width: 120px;
}

.gs_el_ta #gs_ab_ttl,
.gs_el_ph #gs_ab_ttl {
    min-width: 0;
}

#gs_ab_ttl,
#gs_ab_ttll {
    font-size: 18px;
    color: #666;
    text-transform: none;
}

.gs_el_sm #gs_ab_ttl,
.gs_el_sm #gs_ab_ttll {
    font-size: 16px;
}

#gs_ab_ttll {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}

#gs_ab_md {
    flex: 1 0 auto;
}

.gs_ab_st #gs_ab_md {
    flex: 1 1 auto;
    font-size: 13px;
    line-height: 17px;
    padding: 0 8px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
}

.gs_el_ph .gs_ab_st #gs_ab_md {
    visibility: hidden;
    padding: 0;
}

#gs_ab_btns {
    margin-right: 8px;
}

.gs_el_sm #gs_ab_btns {
    margin-right: 0;
}

.gs_el_ta #gs_ab_btns,
.gs_el_ph #gs_ab_btns {
    margin-right: 4px;
}

#gs_ab_ttl:before,
#gs_ab_md:before,
#gs_ab_btns:before {
    content: "";
    display: inline-block;
    width: 0;
    height: 100%;
    vertical-align: middle;
}

#gs_ab_md>button,
#gs_ab_btns>button,
#gs_ab_md>.gs_in_ib,
#gs_ab_btns>.gs_in_ib,
#gs_ab_md>.gs_md_r,
#gs_ab_btns>.gs_md_r,
#gs_ab .gs_ab_mdw,
#gs_ab .gs_ab_btw {
    margin: 0 8px;
    vertical-align: middle;
}

#gs_ab .gs_ab_mdw,
.gs_ab_btw {
    display: inline-block;
    margin: 0;
}

#gs_ab_btns>.gs_in_ib {
    margin: 0 16px 0 8px;
}

#gs_ab_btns>#gs_ab_btns_u {
    margin: 0 12px 0 0;
}

.gs_el_ph #gs_ab_btns>#gs_ab_btns_u.gs_ab_btns_npu {
    visibility: hidden;
    margin-left: -41px;
}

#gs_ab .gs_ab_btw {
    margin: 0 12px 0 16px;
}

.gs_el_ta .gs_ab_sel #gs_ab_ico,
.gs_el_ph .gs_ab_sel #gs_ab_ico,
.gs_el_ta .gs_ab_sel #gs_ab_ttl,
.gs_el_ph .gs_ab_sel #gs_ab_ttl,
.gs_el_ta .gs_ab_sel #gs_ab_btns,
.gs_el_ph .gs_ab_sel #gs_ab_btns {
    display: none;
}

#gs_bdy {
    display: table;
    table-layout: fixed;
    width: 100%;
}

#gs_bdy_sb {
    vertical-align: top;
    width: 236px;
    word-wrap: break-word;
    display: table-cell;
}

.gs_el_sm #gs_bdy_sb {
    width: 136px;
}

.gs_el_ta #gs_bdy_sb,
.gs_el_ph #gs_bdy_sb {
    display: none;
}

.gs_bdy_sb_sec {
    margin: 0 40px 0 56px;
}

.gs_el_sm .gs_bdy_sb_sec {
    margin: 0 0 0 16px;
}

.gs_bdy_sb_sec:before {
    display: block;
    content: " ";
    height: 0;
    margin: 13px 0;
    border-top: 1px solid #eee;
}

.gs_bdy_sb_sec:first-child:before {
    margin: 21px 0 0 0;
    border: none;
}

.gs_el_sm .gs_bdy_sb_sec:first-child:before {
    margin-top: 15px;
}

#gs_bdy_sb ul {
    list-style-type: none;
}

.gs_bdy_sb_sec a:link,
.gs_bdy_sb_sec a:visited {
    color: #222;
}

.gs_bdy_sb_sec a:active {
    color: #d14836;
}

.gs_bdy_sb_sel a:link,
.gs_bdy_sb_sel a:visited {
    color: #d14836;
    text-decoration: none;
}

.gs_el_tc .gs_bdy_sb_sec li.gs_ind,
.gs_el_tc .gs_bdy_sb_sec li.gs_ind a {
    padding-top: 8px;
    padding-bottom: 5px;
}

.gs_el_tc .gs_bdy_sb_sec:first-child li.gs_ind:first-child {
    margin-top: -8px;
}

#gs_bdy_sb .gs_ind,
#gs_bdy_sb .gs_inw {
    margin-bottom: 6px;
}

.gs_el_tc #gs_bdy_sb .gs_ind,
.gs_el_tc #gs_bdy_sb .gs_inw {
    margin-bottom: 0;
}

#gs_bdy_ccl {
    display: table-cell;
    vertical-align: top;
    padding: 0 24px 0 16px;
}

.gs_el_sm #gs_bdy_ccl {
    padding: 0 16px;
}

.gs_el_ta #gs_bdy_ccl,
.gs_el_ph #gs_bdy_ccl {
    padding: 0 16px;
}

.gs_el_ph #gs_bdy_ccl {}

#gs_ftr_sp {
    height: 62px;
}

.gs_el_sm #gs_ftr_sp {
    height: 57px;
}

#gs_ftr {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    white-space: nowrap;
    border-top: 1px solid #e4e4e4;
    background-color: #f2f2f2;
    display: flex;
}

#gs_ftr_rt {
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: auto;
    margin-left: auto;
    padding: 0 12px;
}

.gs_el_sm #gs_ftr_rt {
    padding: 0 8px;
}

.gs_el_ph #gs_ftr_rt:after {
    content: " ";
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 100%;
    background-image: linear-gradient(to right, rgba(242, 242, 242, 0), rgba(242, 242, 242, 1) 80%);
}

#gs_ftr_rt a {
    display: inline-block;
    line-height: 16px;
    padding: 12px;
    white-space: nowrap;
}

.gs_el_sm #gs_ftr_rt a {
    padding: 12px 8px;
}

#gs_ftr_rt a:link,
#gs_ftr_rt a:visited {
    color: #666
}

#gs_ftr_rt a:active {
    color: #d14836
}

.gs_res_sb_yyr {
    padding: 5px 0;
    text-align: center;
    white-space: nowrap;
}

.gs_el_tc .gs_res_sb_yyr {
    padding: 10px 0;
}

.gs_res_sb_yyr .gs_in_txt {
    width: 48px;
}

#gs_res_ccl {
    max-width: 1050px;
    padding-top: 10px;
}

.gs_el_sm #gs_res_ccl {
    padding-top: 7px;
}

.gs_el_tc #gs_res_ccl {
    padding-top: 6px;
}

.gs_el_sm.gs_el_tc #gs_res_ccl {
    padding-top: 0;
}

.gs_r {
    position: relative;
    line-height: 1.46;
    padding: 11px 0 16px 0;
}

.gs_el_sm .gs_r {
    padding: 7px 0 6px 0;
}

.gs_el_tc .gs_r {
    padding: 15px 0;
    border-bottom: 1px solid #eee;
}

.gs_rt {
    position: relative;
    font-weight: normal;
    font-size: 17px;
    line-height: 19px;
    margin-right: 100px;
    margin-bottom: 2px;
}

.gs_el_tc .gs_rt {
    margin-bottom: 0;
}

.gs_el_ph .gs_rt {
    margin-right: 0;
}

.gs_rt2 {
    font-size: 13px;
    font-weight: normal;
}

.gs_or_ggsm:focus {
    outline: none;
}

.gs_ggs {
    position: relative;
    z-index: 1;
    float: right;
    margin-left: 24px;
    min-width: 200px;
    max-width: 256px;
    width: 200px;
    width: calc(100% - 620px);
    font-size: 17px;
    line-height: 19px;
}

.gs_el_sm .gs_ggs {
    margin-left: 16px;
}

@media (max-width: 699px) {
    .gs_el_sm .gs_ggs {
        min-width: 0;
        width: 182px;
    }
}

.gs_el_ph .gs_ggs {
    width: 72px;
    height: 43px;
}

.gs_el_tc .gs_ggs {
    margin-top: -14px;
}

.gs_el_ph .gs_ggsd {
    position: absolute;
    top: -1px;
    right: 0;
    width: 72px;
    height: 43px;
    overflow: hidden;
    transition: width 0s .3s, height 0s .3s;
}

.gs_el_ph .gs_ggsd.gs_vis {
    width: 208px;
    height: 88px;
    transition: none;
}

.gs_or_ggsm a {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
}

.gs_el_tc .gs_or_ggsm a {
    padding: 13px 8px 9px 8px;
    touch-action: none;
    background: #fff;
    height: 19px;
    margin-bottom: 0;
}

.gs_el_ph .gs_or_ggsm a {
    text-decoration: none;
}

.gs_el_ph .gs_or_ggsm a:focus {
    outline: none;
    background: #f1f1f1;
}

.gs_el_ph .gs_or_ggsm a:active {
    color: #1a0dab;
}

.gs_el_ph .gs_or_ggsm a:visited {
    color: #660099;
}

.gs_el_ph .gs_or_ggsm {
    position: absolute;
    top: 0;
    right: -132px;
    margin-right: 4px;
    padding: 1px 0;
    width: 200px;
    height: 41px;
    transform: translate(0, 0);
}

.gs_el_ph .gs_or_ggsm.gs_vis {
    right: 0;
    height: auto;
}

.gs_el_ph .gs_or_ggsm>a:nth-child(2) {
    height: 0;
    transform: scale(1, 0);
    transform-origin: 0 0;
}

.gs_el_ph .gs_or_ggsm.gs_vis>a:nth-child(2) {
    height: 19px;
    transform: scale(1, 1);
}

.gs_el_ph .gs_or_ggsm:before {
    content: "";
    position: absolute;
    top: 0;
    left: -1px;
    right: -1px;
    bottom: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
    border: 1px solid #ccc;
    opacity: 0;
    z-index: -1;
}

.gs_el_ph .gs_or_ggsm.gs_vis:before {
    opacity: 1;
    transition: opacity 0s .3s;
}

.gs_el_ph .gs_or_ggsm:after {
    content: "";
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-image: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1) 65%, rgba(255, 255, 255, 0) 70%);
}

.gs_el_ph .gs_or_ggsm.gs_vis:after {
    visibility: hidden
}

.gs_el_ph .gs_or_ggsm.gs_vis.gs_anm {
    animation: gs_anm_hsli .218s ease-in-out;
}

.gs_el_ph .gs_or_ggsm.gs_anm {
    animation: gs_anm_hslo .218s ease-out;
}

.gs_el_ph .gs_ggs .gs_or_ggsm.gs_vis.gs_anm>a:nth-child(2) {
    animation: gs_anm_vscli .218s ease-in;
}

@keyframes gs_anm_hsli {
    0% {
        transform: translate(66%, 0);
        height: 41px;
    }

    99% {
        transform: translate(0, 0);
        height: 41px;
    }

    100% {
        transform: translate(0, 0);
        height: auto;
    }
}

@keyframes gs_anm_hslo {
    0% {
        transform: translate(-66%, 0);
    }

    100% {
        transform: translate(0, 0);
    }
}

@keyframes gs_anm_vscli {
    0% {
        transform: scale(1, 0);
    }

    100% {
        transform: scale(1, 1);
    }
}

.gs_ct1 {
    display: inline
}

.gs_ct2 {
    display: none
}

.gs_el_ph .gs_ct1 {
    display: none
}

.gs_el_ph .gs_ct2 {
    display: inline;
    font-size: 13px;
    font-weight: normal
}

.gs_ri {
    max-width: 712px
}

.gs_a a:link,
.gs_a a:visited {
    text-decoration: underline;
}

.gs_ri .gs_fl a,
.gs_a a {
    white-space: nowrap;
}

.gs_ri .gs_fl a.gs_wno {
    white-space: normal;
}

.gs_ri .gs_fl {
    font-size: 1px;
}

.gs_ri .gs_fl a {
    font-size: 13px;
    margin-right: 12px;
}

.gs_ri .gs_fl a:last-child {
    margin-right: 0;
}

.gs_ri .gs_fl .gs_or_mor {
    margin: -7px 6px -6px -6px;
    padding: 7px 0 6px 0;
    border-radius: 50%;
}

.gs_ri .gs_fl .gs_or_sav:hover,
.gs_ri .gs_fl .gs_or_cit:hover,
.gs_ri .gs_fl .gs_or_mor:hover {
    background-color: rgba(0, 0, 0, .05);
}

.gs_el_ph .gs_ri .gs_fl .gs_or_sav,
.gs_el_ph .gs_ri .gs_fl .gs_or_cit {
    margin-right: 4px;
}

.gs_el_ph .gs_ri .gs_fl .gs_or_mor {
    margin-right: -8px;
}

.gs_or_svg {
    position: relative;
    width: 15px;
    height: 16px;
    vertical-align: text-bottom;
    fill: none;
    stroke: #1a0dab;
}

.gs_or:not([data-lid=""]) .gs_or_sav .gs_or_svg {
    fill: #1a0dab;
}

.gs_or[data-lid] .gs_or_ldg .gs_or_svg {
    fill: #eee;
    animation: gs_anm_spin 1.2s .5s linear infinite;
}

a:active .gs_or_svg,
a .gs_or_svg:active,
a .gs_or_svg>*:active {
    stroke: #dd4b39;
}

.gs_or_nvi,
.gs_or_mvi .gs_or_mor {
    display: none
}

.gs_or_mvi .gs_or_nvi,
.gs_or_mvi .gs_nph,
.gs_or_mvi .gs_nta {
    display: inline
}

.gs_rs {
    margin: 2px 0;
    word-wrap: break-word;
}

.gs_el_tc .gs_rs {
    margin: 0
}

.gs_el_ta .gs_rs {
    margin-right: 10%
}

@media (max-width: 780px) {

    .gs_el_ta .gs_rs,
    .gs_el_ta .gs_a {
        margin-right: 100px;
    }
}

.gs_el_ph .gs_rs br,
.gs_el_ta .gs_rs br {
    display: none
}

@media screen and (min-width: 771px) {
    .gs_el_ta .gs_rs br {
        display: block
    }
}

.gs_age {
    color: #777777
}

.gs_rs b,
.gs_rt b,
.gs_rt2 b {
    color: #000
}

.gs_el_tc .gs_rt a {
    font-size: 17px;
    line-height: 20px;
    padding: 12px 0 9px 0;
}

.gs_el_tc .gs_rt2 a {
    font-size: 14px;
    line-height: 20px;
    padding: 6px 0 4px 0;
}

.gs_el_tc .gs_a,
.gs_el_tc .gs_a a,
.gs_el_tc .gs_ri .gs_fl a {
    padding-top: 7px;
    padding-bottom: 6px;
}

.gs_el_tc .gs_ri .gs_fl a {
    line-height: 29px;
}

.gs_el_tc .gs_ri .gs_fl {
    margin-bottom: -6px;
}

#gs_n {
    clear: both;
    margin: 1.5em 0;
    width: 600px;
    text-align: center;
}

#gs_n td {
    font-size: 13px
}

#gs_n a:link,
#gs_n a:visited {
    color: #1a0dab
}

#gs_n a:active {
    color: #d14836
}

#gs_nm {
    clear: both;
    position: relative;
    text-align: center;
    max-width: 500px;
    margin: 24px 50px;
    font-size: 15px;
    line-height: 41px;
    display: none;
}

#gs_nm button {
    position: absolute;
    top: 0
}

#gs_nm .gs_btnPL {
    left: -50px
}

#gs_nm .gs_btnPR {
    right: -50px
}

#gs_nml {
    overflow: hidden;
    white-space: nowrap;
}

.gs_nma {
    display: inline-block;
    width: 40px;
    margin: 0 5px;
}

.gs_el_tc #gs_n,
.gs_el_ta #gs_n,
.gs_el_ph #gs_n {
    display: none
}

.gs_el_tc #gs_nm,
.gs_el_ta #gs_nm,
.gs_el_ph #gs_nm {
    display: block
}

#gs_bdy_sb_ca {
    margin-top: -6px;
}

.gs_el_tc #gs_bdy_sb_ca {
    margin-top: 2px;
}

@media print {

    #gs_gb,
    #gs_hdr,
    #gs_ab,
    #gs_top #gs_bdy_sb,
    .gs_pda,
    .gs_ggs,
    .gs_alrt_btm,
    #gs_top #gs_n,
    #gs_top #gs_nm,
    #gs_ftr,
    #gs_top .gs_ctc,
    #gs_top .gs_ctu,
    #gs_rt_hdr,
    .gs_rt_hdr_ttl {
        display: none
    }

    #gs_top,
    #gs_top #gs_bdy,
    #gs_top #gs_res_bdy,
    #gs_top #gs_bdy_ccl,
    #gs_top .gs_r,
    #gs_top .gs_ri,
    #gs_top .gs_rs {
        font-size: 9pt;
        color: black;
        position: static;
        float: none;
        margin: 0;
        padding: 0;
        width: auto;
        min-width: 0;
        max-width: none;
    }

    #gs_top #gs_bdy a {
        color: blue;
        text-decoration: none
    }

    #gs_top .gs_r {
        margin: 1em 0;
        page-break-inside: avoid;
        border: 0;
    }

    #gs_top .gs_med,
    #gs_top .gs_rt {
        font-size: 12pt
    }

    #gs_top .gs_a,
    #gs_top #gs_bdy .gs_a a {
        font-size: 9pt;
        color: green
    }

    #gs_top .gs_fl,
    #gs_top .gs_fl a {
        font-size: 9pt
    }

    #gs_top .gs_rs br {
        display: inline
    }
}

.gs_el_ph #gs_ab_ttll {
    max-width: 98px;
    max-width: calc(100vw - 222px);
}

@media (max-width: 320px) {
    .gs_el_ph #gs_ab_ttll {
        max-width: 98px;
    }
}

#gs_res_ab_yy-r,
#gs_res_ab_ad-r {
    display: none;
}

.gs_el_ta #gs_res_ab_yy-r,
.gs_el_ph #gs_res_ab_yy-r,
.gs_el_ta #gs_res_ab_ad-r,
.gs_el_ph #gs_res_ab_ad-r {
    display: inline-block;
    margin: 0;
}

#gs_res_ab_yy-r:last-child {
    margin-right: 4px;
}

#gs_res_ab_ad-r:last-child {
    margin-right: 12px;
}

#gs_res_ab_tmn-d,
#gs_res_ab_yy-d,
#gs_res_ab_ad-d {
    white-space: normal;
    word-wrap: break-word;
    width: 208px;
    width: -webkit-max-content;
    width: max-content;
    min-width: 100px;
    max-width: 208px;
}

#gs_res_ab_yy-d,
#gs_res_ab_ad-d {
    left: auto;
    right: 0;
}

.gs_res_ab_dd_bdy {
    padding: 8px 0;
    box-sizing: border-box;
}

.gs_res_ab_dd_sec a.gs_res_ab_sel,
.gs_res_ab_dd_sec a[role=menuitemradio]:active {
    color: #d14836;
}

.gs_res_ab_dd_sec:before {
    display: block;
    content: " ";
    height: 0;
    border-bottom: 1px solid #e5e5e5;
    margin: 8px 0;
}

.gs_res_ab_dd_sec:first-child:before {
    display: none;
}

.gs_fsvg line {
    stroke: #222222
}

a:link .gs_fsvg {
    fill: #1a0dab;
}

a:link .gs_fsvg line {
    stroke: #1a0dab;
}

a:visited .gs_fsvg {
    fill: #660099;
}

a:visited .gs_fsvg line {
    stroke: #660099;
}

a:active .gs_fsvg {
    fill: #d14836;
}

a:active .gs_fsvg line {
    stroke: #d14836;
}

a .gs_fsvg {
    border-bottom: 1px solid transparent;
}

a:hover .gs_fsvg,
a:focus .gs_fsvg {
    border-bottom-color: inherit;
}

.gs_fsml {
    font-size: 13px
}

.gs_fscp {
    font-variant: small-caps
}

.gs_qsuggest {
    max-width: 712px;
    line-height: 21px;
    margin-bottom: 2px;
}

.gs_r .gs_qsuggest {
    max-width: 600px;
}

.gs_el_ta .gs_r .gs_qsuggest {
    margin-right: 100px;
}

.gs_qsuggest h2 {
    margin-bottom: 8px;
    font-weight: normal;
    font-size: 17px;
}

.gs_qsuggest li {
    display: inline-block;
    width: 100%;
    font-size: 15px;
    line-height: 18px;
    padding: 4px 0 3px;
}

.gs_qsuggest ul {
    list-style-type: none;
    columns: 2;
    column-gap: 40px;
    margin-bottom: -3px;
}

.gs_el_sm .gs_qsuggest ul {
    column-gap: 16px;
    margin-bottom: 3px;
}

.gs_qsuggest li:only-child {
    column-span: all;
}

.gs_qsuggest li>a {
    display: inline-block;
    max-width: 100%;
    word-wrap: break-word;
}

.gs_qsuggest b {
    font-weight: normal;
}

.gs_el_tc .gs_qsuggest a {
    padding: 8px 0 5px;
}

.gs_el_tc .gs_qsuggest li {
    padding: 2px 0 1px;
}

.gs_el_tc .gs_qsuggest ul {
    margin: 0;
}

.gs_el_tc .gs_qsuggest h2 {
    margin: 6px 0;
}

.gs_qsuggest_bottom h2 {
    padding-top: 16px;
}

.gs_el_tc .gs_qsuggest_wrap .gs_qsuggest_related h2 {
    padding-bottom: 0;
}

.gs_el_ph .gs_r .gs_qsuggest {
    margin-bottom: -15px;
}

.gs_el_ph .gs_qsuggest ul {
    columns: 1;
    margin: 0;
}

.gs_el_ph .gs_qsuggest li {
    margin: 0;
    padding: 0;
    position: relative;
}

.gs_el_ph .gs_qsuggest h2 {
    margin: 1px 0 16px;
}

.gs_el_ph .gs_qsuggest a {
    display: block;
    padding: 11px 29px 9px 0;
    border-bottom: 1px solid #eee;
}

.gs_el_ph .gs_qsuggest li:first-child a {
    border-top: 1px solid #eee;
}

.gs_el_ph .gs_qsuggest_wrap.gs_r li:last-child a {
    border-bottom: 0;
}

.gs_el_ph .gs_qsuggest a:link,
.gs_el_ph .gs_qsuggest a:visited {
    color: #222;
}

.gs_el_ph .gs_qsuggest a:hover,
.gs_el_ph .gs_qsuggest a:focus {
    background: #f1f1f1;
    text-decoration: none;
    outline: none;
}

.gs_el_ph .gs_qsuggest li>a:after {
    content: "";
    position: absolute;
    width: 7px;
    height: 7px;
    top: 50%;
    margin-top: -4px;
    right: 10px;
    border: 2px solid #777;
    border-left: none;
    border-bottom: none;
    transform: rotate(45deg);
}
</style>
<style>
#gs_top {
    font-size: 13px;
    font-family: Arial, sans-serif;
    line-height: 1.24;
}

#gs_top .el-pagination>button:disabled {
    color: #a1a1a1;
    visibility: hidden;
}

#gs_top .el-pagination>button>span {
    color: #1a0dab;
    font-weight: 700;
}

#gs_top .el-pager li {
    color: #1a0dab;
}

#gs_top .el-pager li.active {
    color: #ff1313;
}

#gs_top .el-pager li:hover {
    color: #ff1313;
}

#gs_top a {
    text-decoration: none;
}


#gs_cit,
#cite_cit {
    width: 520px;
    max-width: 80%;
}

.gs_el_ph #gs_cit,
.gs_el_ph #cite_cit {
    width: 100%;
    max-width: 100%;
}

#gs_citt table,
#cite_citt table {
    width: 100%;
    margin-top: -8px;
}

#gs_citt td,
#gs_citt th,
#cite_citt td,
#cite_citt th {
    vertical-align: top;
    padding: 8px 0;
}

#gs_citt th,
#cite_citt th {
    text-align: right;
    font-weight: normal;
    color: #777;
    padding-right: 16px;
    white-space: nowrap;
    -webkit-user-select: none;
    user-select: none;
}

#gs_citi #cite_citi {
    margin: 16px 0 0 0;
    text-align: center;
}

.gs_el_ph #gs_citi,
.gs_el_ph #cite_citi {
    margin: 16px 0 8px 0;
}

.gs_citi {
    margin-right: 16px;
    white-space: nowrap;
    padding: 7px 0 5px 0;
}

.gs_citi:first-child,
.cite_citi:first-child {
    margin-left: 16px;
}

#gs_citi a:link,
#cite_citi a:link {
    color: #1a0dab;
    text-decoration: none;
    font-size: 13px;

    font-family: Arial, sans-serif;
}

#gs_citt .gs_cith,
#cite_citt .gs_cith {
    font-size: 13px;
    font-family: Arial, sans-serif;
}

#gs_citt .gs_citr,
#cite_citt .gs_citr {
    font-size: 13px;
    font-family: Arial, sans-serif;
}


.gs_ctg,
.gs_ctg2 {
    font-size: 13px;
    font-weight: bold;
    font-family: Arial, sans-serif;
}

.gs_ctg {
    color: #1a0dab
}

.gs_r b,
.gs_r a:link b,
.gs_r a:visited b {
    color: #dd4b39 !important;
    font-weight: normal
}

.gs_rt a:link,
.gs_rt a:link b,
.gs_rt2 a:link,
.gs_rt2 a:link b {
    color: #1a0dab
}

.gs_rt a:visited,
.gs_rt a:visited b,
.gs_rt2 a:visited,
.gs_rt2 a:visited b {
    color: #660099
}

.gs_rt a:active,
.gs_rt a:active b,
.gs_rt2 a:active,
.gs_rt2 a:active b {
    color: #d14836
}

.gs_ctc {
    color: #1a0dab;
}

.gs_ctc,
.gs_ctu {
    vertical-align: middle;
    font-size: 13px;
    font-weight: normal;
}

#gs_hdr_md {
    display: flex !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-content: space-between !important;
}

#gs_hdr_md>#gs_hdr_srch {
    flex-grow: 1;
    /* flex-shrink: 0; */
    /* flex-basis: 600px; */
    max-width: 800px !important;
    min-width: 600px !important;
    /* max-width:600px !important; */
}

.tool_ul_panel {
    flex-grow: 2;
    /*
    display:block; */
    height: 40px;
    /* width: 800px; */
    padding-left: 60px !important;
    overflow: hidden;
}

.tool_ul_panel>.tool_ul {
    width: 100%;
    height: 20px;
    overflow: hidden;
}

.tool_ul_panel>.tool_ul>li {
    margin-left: 30px !important;
    float: left;
    width: 90px;
    height: 100%;
}

.tool_ul_panel>.tool_ul>li>a {

    color: #222;
    display: inline-block;
    height: 100%;
    line-height: 20px;
    text-decoration: auto !important;
    position: unset !important;
}

.tool_ul_panel>.tool_ul>li>a:link {
    color: #222;
}

.tool_ul_panel>.tool_ul>li>a:visited {
    color: #222;
}

.tool_ul_panel>.tool_ul>li>a:hover {
    color: #14aab9;
}

.tool_ul_panel>.tool_ul>li>a>span {
    display: inline-block;
    margin-left: 4px;
    height: 20px;
    line-height: 20px;
    text-decoration: auto !important;
    position: unset !important;
    font-size: 14px;
}

.tool_ul_panel>.tool_ul img {
    display: inline-block;
    width: 12px;
    height: 12px;
    vertical-align: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/PaperSearchResult.vue